<template>
    <div class="col-md-12">
        <div class="flash-message">
            <FlashMessage :position="'top'"></FlashMessage>
        </div>
        <form @submit.prevent="addBooking">
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="10 col-sm-10 col-lg-10">
                        <div class="form-group row">
                            <div class="h2">Create booking
                                <div class="dependent-booking" v-if="booking.createDependingBooking">
                                    RETURN FOR B-{{ booking.createDependingBooking }}
                                </div>
                            </div>
                            <div v-if="role!=='user'"
                                 class="btn d-flex align-items-center float-left address-type"
                                 :class="booking.bookingType===1 ? 'btn-success': 'btn-default' "
                                 @click="booking.bookingType=1"
                                 title="internal">
                                <span class="">Internal</span>
                            </div>

                            <div v-if="role!=='user'"
                                 class="btn d-flex align-items-center float-left address-type"
                                 :class="booking.bookingType===2 ? 'btn-success': 'btn-default' "
                                 @click="booking.bookingType=2"
                                 title="external">
                                <span class="">External</span>
                            </div>
                        </div>


                        <br/>
                        <div class="col-md-4">
                            <div class="form-group">
                                <div v-if="!isEditableClient" class="align-items-center">
                                    <span> <strong> {{ booking.clientId.name }}  </strong> </span>
                                </div>
                                <div v-else>
                                    <label for="client-name"
                                           class="d-block mb-0 font-weight-bold">Client</label>
                                    <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                        <v-select
                                            :options="clientList"
                                            v-model="booking.clientId"
                                            @input="getClientAddresses();getClientAgreements();showClientColliList=false;"
                                            label="name"
                                            id="client-name"
                                        >
                                        </v-select>
                                    </div>
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                         :class="booking.clientId==='' && isSubmit? 'border-danger':''">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group"
                                 :class="booking.isExternalDriver==1 ? 'hide-agreement' : ''"
                            >
                                <div v-if="!isEditableClient && !isEditableAgreement" class="align-items-center">
                                    <span> <strong> {{ clientAgreementSingleName }} </strong> </span>
                                </div>
                                <div v-else-if="isEditableClient || isEditableAgreement">
                                    <label for="agreement-name"
                                           class="d-block mb-0 font-weight-bold">Agreement</label>
                                    <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                         :class="booking.clientAgreement==='' && isSubmit? 'border-danger':''">
                                        <select
                                            id="agreement-name"
                                            class="form-control border-0 py-0 shadow-none pr-5"
                                            v-model="booking.clientAgreement"
                                            @change="calculatePrice($event);getAgreementsProductsServices($event)">
                                            <option v-for="item in clientAgreements"
                                                    v-bind:value="item.id">
                                                {{  types[item.type] }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group"
                                 v-if="role!=='user' && (booking.isExternalDriver==1 || booking.bookingType==2)">
                                <label for="driver-name"
                                       class="d-block mb-0 font-weight-bold">Driver</label>
                                <div class="align-items-center">
                                    <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                        <v-select
                                            :required="booking.isExternalDriver==1"
                                            :options="driverList"
                                            v-model="booking.driverId"
                                            :clearSearchOnSelect="false"
                                            label="name"
                                            id="driver-name"
                                        >
                                        </v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group" v-if="role!=='user'">
                                <div class="custom-control- custom-checkbox- mb-3">
                                    <label class="custom-control-label-" for="instantly_delivered">
                                        <b>Mark booking as instantly delivered:</b>
                                    </label>
                                    <input type="checkbox" class="custom-control-input-"
                                           id="instantly_delivered"
                                           v-model="booking.is_instantly_delivered">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2 col-sm-2 col-lg-2"></div>

                </div>
            </div>
            <div class="container-fluid bg-light py-3">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">Pickup address</div>
                            <div>
                                <div class="form-group row">
                                    <div
                                        class="btn d-flex align-items-center float-left address-type"
                                        :class="booking.pickup_address_type===1 ? 'btn-success': 'btn-default' "
                                        @click="booking.pickup_address_type=1;removeDefaultStepAddress(1)"
                                        title="client">
                                        <span
                                            class="">{{
                                                booking.clientId.name !== '' ? booking.clientId.name : 'Client'
                                            }}
                                        </span>
                                    </div>

                                    <div
                                        class="btn d-flex align-items-center float-left address-type"
                                        :class="booking.pickup_address_type===2 ? 'btn-success': 'btn-default' "
                                        @click="booking.pickup_address_type=2;setDefaultStepAddress(1)"
                                        title="Step Transport">
                                        <span class="">Step Transport</span>
                                    </div>

                                    <div
                                        class="btn d-flex align-items-center float-left address-type"
                                        :class="booking.pickup_address_type===3 ? 'btn-success': 'btn-default' "
                                        @click="onClickCustomerAddress(1)"
                                        title="customer">
                                        <span class="">Customer</span>
                                    </div>
                                </div>

                                <div>
                                    <div class="form-group">
                                        <div class="form-group row">
                                            <div class="col-md-6">

                                                <v-select
                                                    class="address-select"
                                                    :options="pickupClientAddresses"
                                                    v-model="booking.pickupAddress"
                                                    v-on:input="onChangePickupAddress($event)"
                                                    label="value"
                                                >
                                                </v-select>
                                            </div>
                                            <div class="col-md-6"></div>
                                        </div>
                                    </div>

                                    <div v-if="booking.pickup_address_type!==2 && booking.pickup_address_type!==1">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupAddressName==='' && isSubmit? 'border-danger':''">
                                                        <input type="text"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="Full Name"
                                                               autocomplete="off"
                                                               v-model="booking.pickupAddressName">
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-12">

                                                    <div><strong>Fully selected: {{ isSingleMatchPickup }}</strong></div>

                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupAddressStreet==='' && isSubmit? 'border-danger':''">
                                                        <div class="autocomplete-container" v-if="booking.pickupAddressCountryId == 1">
                                                            <input autocomplete="off" required type="text"
                                                                   id="pickupAddressStreet"
                                                                   v-adressevaelger="'pickup'"
                                                                   aria-label="Pickup address"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   placeholder="Address"
                                                                   @input="selectedAddresses.pickup = null"
                                                                   v-model="booking.pickupAddressStreet">
                                                        </div>
                                                        <div v-else>
                                                            <input autocomplete="off" required type="text"
                                                                   class="form-control border-0 py-0 shadow-none form-input"
                                                                   placeholder="Address"
                                                                   v-model="booking.pickupAddressStreet">
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-4">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupAddressZip==='' && isSubmit? 'border-danger':''">
                                                        <input autocomplete="off" required type="text"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="Zip"
                                                               v-model="booking.pickupAddressZip"
                                                               @input="getCityByZip($event,'pickup')"
                                                        >
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupAddressCity==='' && isSubmit? 'border-danger':''">
                                                        <input autocomplete="off" required type="text"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="City"
                                                               @input="pickupAddressManuallyChanged"
                                                               v-model="booking.pickupAddressCity">
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupAddressCountryId==='' && isSubmit? 'border-danger':''">
                                                        <select @change="onChangePickupCountry"
                                                                class="form-control border-0 py-0 shadow-none pr-5"
                                                                v-model="booking.pickupAddressCountryId">
                                                            <option v-for="item in countryList" :value="item.id">
                                                                {{ item.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="booking.pickup_address_type!==2">
                                        <div class="form-group row">
                                            <div
                                                class="btn d-flex align-items-center float-left address-type"
                                                :class="booking.pickup_delivery_is_known===0 ? 'btn-success': 'btn-default' "
                                                @click="booking.pickup_delivery_is_known=0"
                                                title="">
                                                <span class="" @click="removeDeliveryDate(1)">Step Transport arranges delivery</span>
                                            </div>

                                            <div
                                                v-if="showIKnowDeliveryButtonPickup"
                                                class="btn d-flex align-items-center float-left address-type"
                                                :class="booking.pickup_delivery_is_known===1 ? 'btn-success': 'btn-default' "
                                                @click="booking.pickup_delivery_is_known=1"
                                                title="">
                                                <span class="">I know the pickup</span>

                                            </div>
                                        </div>

                                        <div class="form-group" v-if="booking.pickup_delivery_is_known===1">
                                            <div class="form-group row">
                                                <div class="col-md-4">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupDate==='' && isSubmit? '':''"
                                                    >
                                                        <date-picker
                                                            manual-input
                                                            :disabled-date="disabledDatesPickup"
                                                            :get-classes="getClassesPickup"
                                                            @open="onClickDatePickup"
                                                            @input="onSelectDatePickup"
                                                            v-model="booking.pickupDate" valueType="format"
                                                            input-class="border-0 py-0 shadow-none form-input"
                                                            :lang="datePickerOptions.lang"
                                                            placeholder="dd-mm-yyyy" format="DD-MM-YYYY">
                                                        </date-picker>
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupTimeStart==='' && isSubmit? '':''"
                                                        ref="PickupStartTime">
                                                        <vue-timepicker
                                                            manual-input
                                                            placeholder="Start"
                                                            v-model="booking.pickupTimeStart"
                                                            :hour-range=[hourRangePickup]
                                                            input-class="border-0 py-0 shadow-none form-input">
                                                        </vue-timepicker>
                                                        <span
                                                            class="material-icons-outlined  pr-2 text-primary">schedule</span>
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupTimeEnd==='' && isSubmit? '':''"
                                                        ref="PickupEndTime"
                                                    >
                                                        <vue-timepicker
                                                            manual-input
                                                            placeholder="End"
                                                            v-model="booking.pickupTimeEnd"
                                                            :hour-range=[hourRangePickup]
                                                            input-class="border-0 py-0 shadow-none form-input">
                                                        </vue-timepicker>
                                                        <span
                                                            class="material-icons-outlined  pr-2  text-primary">schedule</span>
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div v-if="booking.pickup_address_type!==2 && booking.pickup_address_type!==1">
                                        <div class="form-group">
                                            <div class="form-group row">
                                                <div class="col-md-8">
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.pickupNote==='' && isSubmit? '':''">
                                                 <textarea
                                                     autocomplete="off"
                                                     class="form-control border-0 py-0 shadow-none form-input"
                                                     placeholder="Til chaufføren, f.eks.: 'Colli afhentes udenfor åbningstid ved lagerrampe'"
                                                     v-model="booking.pickupNote">
                                                     </textarea>
                                                        <div class="help-block with-errors"></div>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <div class="form-group row">
                                                            <div class="col-md-5">
                                                                <div class="d-flex align-items-center bg-white border
                                                                    rounded-lg div-focus border-2"
                                                                     :class="booking.pickupAddressPhone==='' && isSubmit?
                                                                    '':''">
                                                                    <vue-country-code
                                                                        @onSelect="onSelectPickupPrefix"
                                                                        class="form-control border-0 py-0 shadow-none form-input"
                                                                        :defaultCountry="defaultPickupCountry"
                                                                        :disabledFetchingCountry="true"
                                                                        :enabledCountryCode="true">
                                                                    </vue-country-code>
                                                                </div>
                                                            </div>
                                                            <div class="col-md-7">
                                                                <div
                                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                    :class="booking.pickupAddressPhone==='' && isSubmit? '':''">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                                           placeholder="Phone"
                                                                           v-model="booking.pickupAddressPhone">
                                                                    <div class="help-block with-errors"></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <div
                                            v-if="booking.pickup_address_type!==2 && booking.pickup_address_type!==1">
                                            <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="email"
                                                       autocomplete="off"
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="email"
                                                       v-model="booking.pickup_email">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between align-items-start">
                                <div v-if="booking.type !== typeAdHoc">
                                    <div class="font-weight-bold">Services</div>
                                    <div v-for="item in services" v-if="item.service.deleted_at===null && item.service.type === tripTypePickup">
                                        <div>
                                            <label class="newInput">{{ item.service.name }}
                                                <input
                                                    @change="calculatePrice($event);checkServiceName();chooseService(item)"
                                                    type="checkbox"
                                                    :value="item.id"
                                                    v-model="booking.serviceIds">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div style="width: 50%">
                                    <div class="font-weight-bold">Add-ons</div>
                                    <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                        <v-select
                                            :options="agreementAddOnsPickup"
                                            v-model="selectedAddOnsPickup"
                                            @input="recalculateServicePrice(); onSelectAddOn(tripTypePickup);"
                                            label="name"
                                            :multiple=true
                                        >
                                        </v-select>
                                    </div>

                                    <div class="mt-4" v-if="showShorterIntervalOptionsPickup">
                                        <div class="font-weight-bold">Kortere tidsinterval pickup</div>
                                        <v-select
                                            :options="shorterIntervalOptionsPickup"
                                            label="option"
                                            v-model="selectedAddOnOptions[addOnShorterIntervalPickup]"
                                            @input="onSelectAddOnOption(addOnShorterIntervalPickup, tripTypePickup)"
                                        >
                                        </v-select>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-6 col-lg-6">
                        <div class="p-4 mb-0 bg-white rounded-lg">
                            <div class="h3 mb-3">Dropoff address</div>

                            <div class="form-group row">
                                <div
                                    class="btn d-flex align-items-center float-left address-type"
                                    :class="booking.dropoff_address_type===1 ? 'btn-success': 'btn-default' "
                                    @click="booking.dropoff_address_type=1;removeDefaultStepAddress(2)"
                                    title="client">
                                   <span
                                       class="">{{ booking.clientId.name !== '' ? booking.clientId.name : 'Client' }}
                                   </span>
                                </div>

                                <div
                                    class="btn d-flex align-items-center float-left address-type"
                                    :class="booking.dropoff_address_type===2 ? 'btn-success': 'btn-default' "
                                    @click="booking.dropoff_address_type=2;setDefaultStepAddress(2)"
                                    title="Step Transport">
                                    <span class="">Step Transport</span>
                                </div>

                                <div
                                    class="btn d-flex align-items-center float-left address-type"
                                    :class="booking.dropoff_address_type===3 ? 'btn-success': 'btn-default' "
                                    @click="onClickCustomerAddress(2)"
                                    title="customer">
                                    <span class="">Customer</span>
                                </div>
                            </div>
                            <div>
                                <div class="form-group">
                                    <div class="form-group row">
                                        <div class="col-md-6">
                                            <v-select
                                                class="address-select"
                                                :options="dropoffClientAddresses"
                                                v-model="booking.dropoffAddress"
                                                v-on:input="onChangeDropoffAddress($event)"
                                                label="value"
                                            >
                                            </v-select>
                                        </div>
                                        <div class="col-md-6"></div>
                                    </div>
                                </div>
                                <div v-if="booking.dropoff_address_type!==2 && booking.dropoff_address_type!==1">
                                    <div class="form-group">
                                        <div class="form-group row">
                                            <div class="col-md-12">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffAddressName==='' && isSubmit? 'border-danger':''">
                                                    <input type="text"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           placeholder="Full Name"
                                                           autocomplete="off"
                                                           v-model="booking.dropoffAddressName">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="form-group row">
                                            <div class="col-md-12">

                                                <div><strong>Fully selected: {{ isSingleMatchDropoff }}</strong></div>

                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffAddressStreet==='' && isSubmit? 'border-danger':''">
                                                    <div class="autocomplete-container" v-if="booking.dropoffAddressCountryId == 1">
                                                        <input autocomplete="off" required type="text"
                                                               id="dropoffAddressStreet"
                                                               v-adressevaelger="'dropoff'"
                                                               aria-label="Dropoff address"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="Address"
                                                               @input="selectedAddresses.dropoff = null"
                                                               v-model="booking.dropoffAddressStreet">
                                                    </div>
                                                    <div v-else>
                                                        <input autocomplete="off" required type="text"
                                                               class="form-control border-0 py-0 shadow-none form-input"
                                                               placeholder="Address"
                                                               v-model="booking.dropoffAddressStreet">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <div class="form-group row">
                                            <div class="col-md-4">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffAddressZip==='' && isSubmit? 'border-danger':''">
                                                    <input autocomplete="off" required type="text"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           placeholder="Zip"
                                                           v-model="booking.dropoffAddressZip"
                                                           @input="getCityByZip($event,'dropoff')"
                                                    >
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffAddressCity==='' && isSubmit? 'border-danger':''">
                                                    <input autocomplete="off" required type="text"
                                                           class="form-control border-0 py-0 shadow-none form-input"
                                                           placeholder="City"
                                                           @input="dropoffAddressManuallyChanged"
                                                           v-model="booking.dropoffAddressCity">
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffAddressCountryId==='' && isSubmit? 'border-danger':''">
                                                    <select @change="onChangeDropoffCountry"
                                                            class="form-control border-0 py-0 shadow-none pr-5"
                                                            v-model="booking.dropoffAddressCountryId">
                                                        <option v-for="item in countryList" :value="item.id">
                                                            {{ item.name }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="booking.dropoff_address_type!==2">
                                    <div class="form-group row">
                                        <div
                                            class="btn d-flex align-items-center float-left address-type"
                                            :class="booking.dropoff_delivery_is_known===0 ? 'btn-success': 'btn-default' "
                                            @click="booking.dropoff_delivery_is_known=0"
                                            title="">
                                            <span class="" @click="removeDeliveryDate(2)">Step Transport arranges delivery</span>
                                        </div>


                                        <div
                                            v-if="showIKnowDeliveryButtonDropoff"
                                            class="btn d-flex align-items-center float-left address-type"
                                            :class="booking.dropoff_delivery_is_known===1 ? 'btn-success': 'btn-default' "
                                            @click="booking.dropoff_delivery_is_known=1"
                                            title="">
                                            <span class="">I know the dropoff</span>
                                        </div>
                                    </div>

                                    <div class="form-group" v-if="booking.dropoff_delivery_is_known===1">
                                        <div class="form-group row">
                                            <div class="col-md-4">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffDate==='' && isSubmit? '':''"
                                                >
                                                    <date-picker
                                                        manual-input
                                                        :disabled-date="disabledDatesDropoff"
                                                        :get-classes="getClassesDropoff"
                                                        @open="onClickDateDropoff"
                                                        @input="onSelectDateDropoff"
                                                        v-model="booking.dropoffDate"
                                                        valueType="format"
                                                        input-class="border-0 py-0 shadow-none form-input"
                                                        placeholder="dd-mm-yyyy"
                                                        :lang="datePickerOptions.lang"
                                                        format="DD-MM-YYYY">
                                                    </date-picker>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffTimeStart==='' && isSubmit? '':''"
                                                    ref="DropoffStartTime"
                                                >
                                                    <vue-timepicker
                                                        manual-input
                                                        placeholder="Start"
                                                        v-model="booking.dropoffTimeStart"
                                                        :hour-range=[hourRangeDropoff]
                                                        input-class="border-0 py-0 shadow-none form-input">
                                                    </vue-timepicker>
                                                    <span
                                                        class="material-icons-outlined pr-2 text-primary">schedule</span>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffTimeEnd==='' && isSubmit? '':''"
                                                    ref="DropoffEndTime"
                                                >
                                                    <vue-timepicker
                                                        manual-input
                                                        placeholder="End"
                                                        v-model="booking.dropoffTimeEnd"
                                                        :hour-range=[hourRangeDropoff]
                                                        input-class="border-0 py-0 shadow-none form-input">
                                                    </vue-timepicker>
                                                    <span
                                                        class="material-icons-outlined pr-2 text-primary">schedule</span>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="booking.dropoff_address_type!==2 && booking.dropoff_address_type!==1">
                                    <div class="form-group">
                                        <div class="form-group row">
                                            <div class="col-md-8">
                                                <div
                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                    :class="booking.dropoffNote==='' && isSubmit? '':''">
                                                     <textarea
                                                         autocomplete="off"
                                                         class="form-control border-0 py-0 shadow-none form-input"
                                                         placeholder='Til chaufføren, f.eks. "Pakker må stilles i garagen"'
                                                         v-model="booking.dropoffNote">
                                                    </textarea>
                                                    <div class="help-block with-errors"></div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <div class="form-group row">
                                                        <div class="col-md-5">
                                                            <div class="d-flex align-items-center bg-white border
                                                                    rounded-lg div-focus border-2"
                                                                 :class="booking.dropoffAddressPhone==='' && isSubmit?
                                                                    '':''">
                                                                <vue-country-code
                                                                    @onSelect="onSelectDropoffPrefix"
                                                                    class="form-control border-0 py-0 shadow-none form-input"
                                                                    v-model="booking.dropoffAddressPhonePrefix"
                                                                    :defaultCountry="defaultDropoffCountry"
                                                                    :disabledFetchingCountry="true"
                                                                    :enabledCountryCode="true">
                                                                </vue-country-code>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-7">
                                                            <div
                                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                :class="booking.dropoffAddressPhone==='' && isSubmit? '':''">
                                                                <input type="text"
                                                                       autocomplete="off"
                                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                                       placeholder="Phone"
                                                                       v-model="booking.dropoffAddressPhone">
                                                                <div class="help-block with-errors"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="form-group">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <div
                                            v-if="booking.dropoff_address_type!==2 && booking.dropoff_address_type!==1">
                                            <div class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                <input type="email"
                                                       autocomplete="off"
                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                       placeholder="email"
                                                       v-model="booking.dropoff_email">
                                                <div class="help-block with-errors"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between align-items-start">
                                <div v-if="booking.type !== typeAdHoc">
                                    <div class="font-weight-bold">Services</div>
                                    <div v-for="item in services" v-if="item.service.deleted_at===null && item.service.type === tripTypeDropoff">
                                        <div>
                                            <label class="newInput">{{ item.service.name }}
                                                <input
                                                    @change="calculatePrice($event);checkServiceName();chooseService(item)"
                                                    type="checkbox"
                                                    :value="item.id"
                                                    v-model="booking.serviceIds">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div style="width: 50%;">
                                    <div class="font-weight-bold">Add-ons</div>
                                    <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                        <v-select
                                            :options="agreementAddOnsDropoff"
                                            v-model="selectedAddOnsDropoff"
                                            @input="recalculateServicePrice(); onSelectAddOn(tripTypeDropoff);"
                                            label="name"
                                            :multiple=true
                                        >
                                        </v-select>
                                    </div>

                                    <div class="mt-4" v-if="showShorterIntervalOptionsDropoff">
                                        <div class="font-weight-bold">Kortere tidsinterval dropoff</div>
                                        <v-select
                                            :options="shorterIntervalOptionsDropoff"
                                            label="option"
                                            v-model="selectedAddOnOptions[addOnShorterIntervalDropoff]"
                                            @input="onSelectAddOnOption(addOnShorterIntervalDropoff, tripTypeDropoff)"
                                        >
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <br/>

                <div class="row general-row">
                    <div class="col-md-3">
                        <div class="p-4 mb-4 bg-white rounded-lg h-100">
                            <div class="h3 mb-3">General</div>
                            <div class="">
                                <label class="d-block mb-0 font-weight-bold" for="reference">Reference </label>
                                <div class="form-group">
                                    <input type="text" autocomplete="off"
                                           id="reference"
                                           @click="getReferenceFromBookingField=true"
                                           class="form-control"
                                           placeholder='Internt ordrenummer, f.eks. "18839123"'
                                           v-model="booking.reference">
                                    <div class="help-block with-errors"></div>
                                </div>

                                <label class="d-block mb-0 font-weight-bold" for="internal-comment" v-if="role !== roleUser">
                                    Internal Comment
                                </label>
                                <div class="form-group" v-if="role !== roleUser">
                                    <textarea
                                        id="internal-comment"
                                        class="form-control"
                                        v-model="booking.internal_comment">
                                    </textarea>
                                    <div class="help-block with-errors"></div>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="col-md-9">
                        <div class="p-4 mb-4 bg-white rounded-lg h-100">
                            <div class="h3 mb-3">Booking info</div>
                            <div>
                                <div class="form-group mb-0">
                                    <div class="form-group mb-0 row">
                                        <div class="col-md-4">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label for="product-name"
                                                           class="d-block mb-0 font-weight-bold">Products</label>
                                                    <div
                                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                        :class="booking.productId==='' && isSubmit? 'border-danger':''">
                                                        <select @change="calculatePrice($event)" required id="product-name"
                                                                class="form-control border-0 py-0 shadow-none"
                                                                v-model="booking.productId"
                                                        >
                                                            <option v-for="item in products" v-bind:value="item.id"
                                                                    v-if="item.product.deleted_at===null">
                                                                {{ item.product.name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div
                                                        :class="!isEditableClient || booking.isExternalDriver==1 ? 'hide-linehaul' : '' ">
                                                        <label class="d-block mb-0 mt-3 font-weight-bold">Linehaul</label>
                                                        <div class="d-flex align-items-center">
                                                            <span class="form-control-plaintext">
                                                                {{ getLinehaulTypeLabel(booking.linehaulType) }}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div v-if="booking.isExternalDriver==1 || booking.bookingType==2">
                                                        <label for="cost_price"
                                                               class="d-block mb-0 mt-3 font-weight-bold">Cost</label>
                                                        <div
                                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                                            <input
                                                                id="cost_price"
                                                                autocomplete="off"
                                                                :readonly="role==='user'"
                                                                :required="booking.isExternalDriver==1"
                                                                type="text"
                                                                class="form-control  border-0 py-0 shadow-none form-input"
                                                                placeholder=""
                                                                v-model="booking.cost_price"
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-6"></div>
                                            </div>

                                            <div class="row mt-4" v-if="booking.type === typeAdHoc">
                                                <div class="col-md-12">
                                                    <div class="font-weight-bold">Custom services</div>
                                                    <div v-for="(bookingCustomService, k) in bookingCustomServices"
                                                         class="d-flex justify-content-between align-items-center mb-1"
                                                    >
                                                        <div class="align-items-center bg-white border rounded-lg div-focus border-2 mr-1"
                                                             style="width: 90%; height: 100%"
                                                        >
                                                            <v-select
                                                                :options="customServices"
                                                                v-model="bookingCustomServices[k]['name']"
                                                                @input="recalculateServicePrice()"
                                                            >
                                                            </v-select>
                                                        </div>
                                                        <div class="float-right"
                                                             title="Remove"
                                                             @click="deleteCustomService(k)">
                                                            <div class="material-icons-outlined cursor-pointer text-primary"
                                                                 title="delete product">delete
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="mt-3">
                                                        <div class="font-weight-bold">
                                                            Select a custom service
                                                        </div>
                                                        <div>
                                                            <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                                <v-select
                                                                    :options="customServices"
                                                                    v-model="selectedCustomService"
                                                                >
                                                                </v-select>
                                                            </div>
                                                            <button
                                                                type="button"
                                                                class="btn btn-success mt-2"
                                                                @click="addNewCustomService(selectedCustomService)"
                                                            >Add</button>
                                                        </div>
                                                        <div class="mt-3">
                                                            <div class="font-weight-bold">
                                                                Add a new custom service
                                                            </div>
                                                            <div class="align-items-center bg-white border rounded-lg div-focus border-2">
                                                                <input type="text"
                                                                       autocomplete="off"
                                                                       class="form-control border-0 py-0 shadow-none form-input"
                                                                       v-model="newCustomService"
                                                                       :class="{view: true}">
                                                            </div>
                                                            <button
                                                                type="button"
                                                                class="btn btn-success mt-2"
                                                                @click="addNewCustomService(newCustomService)"
                                                            >Add</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="col-md-8" v-if="canViewPrices">
                                            <label class="d-block mb-0 font-weight-bold">Prices </label>
                                            <div class="table-responsive">
                                                <table class="table border"
                                                       :class="booking.colli.length &&
                                                        (!booking.newTotalPriceProductByPiece && !booking.priceProduct) ?
                                                         'border-danger border-width-3': ''"
                                                >
                                                    <thead>
                                                    <tr>
                                                        <th>Product</th>
                                                        <th class="text-center">Price</th>
                                                        <th class="text-center">Amount</th>
                                                        <th class="text-center">Unit</th>
                                                        <th class="text-center">Total Price</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr>
                                                        <td class="text-center">{{
                                                            hasBookingProduct ? getBookingProduct.product.name : ''
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            <div v-if="getBookingProduct.price_type === 1">
                                                                <div
                                                                    class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                    :class="{'border-danger': booking.product_price === '' && isSubmit}">
                                                                    <input type="number"
                                                                           min="0"
                                                                           step="0.01"
                                                                           autocomplete="off"
                                                                           required
                                                                           @input="recalculateServicePrice()"
                                                                           class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                           placeholder="price"
                                                                           v-model="booking.priceProduct"
                                                                           :disabled="!canEditPrices"
                                                                           :class="{view: true}">
                                                                    <div class="help-block with-errors"></div>
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                <div
                                                                    :class="{'border-danger': booking.product_price === '' && isSubmit}">
                                                                    <input type="text"
                                                                           autocomplete="off"
                                                                           min="0"
                                                                           step="0.01"
                                                                           required
                                                                           class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                           placeholder="price"
                                                                           v-model="booking.priceProduct"
                                                                           @input="recalculateServicePrice()"
                                                                           :disabled="!canEditPrices"
                                                                           :class="{view: true}">
                                                                    <div class="help-block with-errors"></div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div
                                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                v-if="getBookingProduct.price_type !== 1">
                                                                <input type="number" min="0" step="0.1"
                                                                       autocomplete="off"
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="time units"
                                                                       :disabled="!canEditPrices"
                                                                       @change="recalculateTimeUnitsProduct($event, booking.id, booking.product_time_units)"
                                                                       :value="booking.product_time_units">
                                                            </div>
                                                            <div v-else>
                                                                {{
                                                                getBookingProduct.price_type === 1 ? 1 :
                                                                booking.product_time_units
                                                                }}
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div v-if="getBookingProduct.price_type === 1">
                                                                pcs
                                                            </div>
                                                            <div v-else-if="getBookingProduct.price_type === 2">
                                                                hours
                                                            </div>
                                                            <div v-else-if="getBookingProduct.price_type === 3">
                                                                days
                                                            </div>
                                                            <div v-else-if="getBookingProduct.price_type === 4">
                                                                weeks
                                                            </div>
                                                            <div v-else-if="getBookingProduct.price_type === 5">
                                                                months
                                                            </div>
                                                            <div v-else>
                                                                years
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            {{ booking.priceProduct }}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="getBookingServices.length > 0">
                                                        <th>Service</th>
                                                        <th class="text-center">Price</th>
                                                        <th class="text-center">Amount</th>
                                                        <th class="text-center">Unit</th>
                                                        <th class="text-center">Total Price</th>
                                                    </tr>

                                                    <tr v-for="service in getBookingServices">
                                                        <td class="text-center"> {{ service.service.name }} ({{ tripTypes[service.service.type] }})</td>
                                                        <td class="text-center">
                                                            <div
                                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                :class="{'border-danger': service.price=== '' && isSubmit}">
                                                                <input type="number"
                                                                       min="0"
                                                                       step="0.01"
                                                                       autocomplete="off"
                                                                       required
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="price"
                                                                       v-model="service.price"
                                                                       @input="recalculateServicePrice()"
                                                                       :disabled="!canEditPrices"
                                                                       :class="{view: true}">
                                                                <div class="help-block with-errors"></div>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div
                                                                v-if="service.service.price_type !== 1">
                                                                <input type="number" min="0" step="0.1"
                                                                       autocomplete="off"
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="time units"
                                                                       @change="recalculateTimeUnitsService($event, service.id, service.time_unit)"
                                                                       :disabled="!canEditPrices"
                                                                       :value="service.time_unit"
                                                                >
                                                            </div>
                                                            <div v-else>
                                                                <div v-if="service.price_type === 1">
                                                                    1
                                                                </div>
                                                                <div v-else>
                                                                    {{ service.time_unit }}
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div v-if="service.price_type===1">
                                                                pcs
                                                            </div>
                                                            <div v-else-if="service.price_type===2">
                                                                hours
                                                            </div>
                                                            <div v-else-if="service.price_type===3">
                                                                days
                                                            </div>
                                                            <div v-else-if="service.price_type===4">
                                                                weeks
                                                            </div>
                                                            <div v-else-if="service.price_type===5">
                                                                months
                                                            </div>
                                                            <div v-else>
                                                                years
                                                            </div>
                                                        </td>
                                                        <td
                                                            class="text-center"
                                                        >
                                                            {{ service.price || recreateServices[service.service.id] }}
                                                        </td>
                                                    </tr>
                                                    <tr v-if="selectedAddOnsPickup.length || selectedAddOnsDropoff.length">
                                                        <th>Add-on</th>
                                                        <th class="text-center">Price</th>
                                                        <th class="text-center">Amount</th>
                                                        <th class="text-center">Unit</th>
                                                        <th class="text-center">Total Price</th>
                                                    </tr>
                                                    <tr v-for="(addOn, index) in selectedAddOnsPickup">
                                                        <td class="text-center">
                                                            <div>{{ addOn.name }} ({{ tripTypes[addOn.type] }})</div>
                                                            <div v-if="addOn.selected_option">
                                                                {{ addOn.selected_option }}
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div
                                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                :class="{'border-danger': selectedAddOnsPickup[index].price === '' && isSubmit}">
                                                                <input type="number"
                                                                       min="0"
                                                                       step="0.01"
                                                                       autocomplete="off"
                                                                       required
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="price"
                                                                       v-model="selectedAddOnsPickup[index].price"
                                                                       @input="recalculateServicePrice()"
                                                                       :disabled="!canEditPrices"
                                                                       :class="{view: true}">
                                                                <div class="help-block with-errors"></div>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">1</td>
                                                        <td class="text-center">pcs</td>
                                                        <td class="text-center">{{ selectedAddOnsPickup[index].price }}</td>
                                                    </tr>
                                                    <tr v-for="(addOn, index) in selectedAddOnsDropoff">
                                                        <td class="text-center">
                                                            <div>{{ addOn.name }} ({{ tripTypes[addOn.type] }})</div>
                                                            <div v-if="addOn.selected_option">
                                                                {{ addOn.selected_option }}
                                                            </div>
                                                        </td>
                                                        <td class="text-center">
                                                            <div
                                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                :class="{'border-danger': selectedAddOnsDropoff[index].price === '' && isSubmit}">
                                                                <input type="number"
                                                                       min="0"
                                                                       step="0.01"
                                                                       autocomplete="off"
                                                                       required
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="price"
                                                                       v-model="selectedAddOnsDropoff[index].price"
                                                                       @input="recalculateServicePrice()"
                                                                       :disabled="!canEditPrices"
                                                                       :class="{view: true}">
                                                                <div class="help-block with-errors"></div>
                                                            </div>
                                                        </td>
                                                        <td class="text-center">1</td>
                                                        <td class="text-center">pcs</td>
                                                        <td class="text-center">{{ selectedAddOnsDropoff[index].price }}</td>
                                                    </tr>
                                                    <tr v-if="bookingCustomServices.length">
                                                        <th>Custom service</th>
                                                        <th class="text-center">Price</th>
                                                        <th class="text-center">Amount</th>
                                                        <th class="text-center">Unit</th>
                                                        <th class="text-center">Total Price</th>
                                                    </tr>
                                                    <tr v-for="(bookingCustomService, index) in bookingCustomServices"
                                                        v-if="bookingCustomService.name"
                                                    >
                                                        <td class="text-center">{{ bookingCustomService.name }}</td>
                                                        <td class="text-center">
                                                            <div
                                                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                                                :class="{'border-danger': bookingCustomServices[index].price === '' && isSubmit}">
                                                                <input type="number"
                                                                       min="0"
                                                                       step="0.01"
                                                                       autocomplete="off"
                                                                       required
                                                                       class="form-control text-center border-0 py-0 shadow-none form-input"
                                                                       placeholder="price"
                                                                       v-model="bookingCustomServices[index].price"
                                                                       @input="recalculateServicePrice()"
                                                                       :disabled="!canEditPrices"
                                                                       :class="{view: true}">
                                                            </div>
                                                        </td>
                                                        <td class="text-center">1</td>
                                                        <td class="text-center">pcs</td>
                                                        <td class="text-center">{{ bookingCustomServices[index].price }}</td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"></td>
                                                        <th class="white-space-nowrap text-right"> Total excl. VAT</th>
                                                        <td class="white-space-nowrap text-center">
                                                            {{
                                                            booking.total_excl_vat ? booking.total_excl_vat.toFixed(2) :
                                                            0
                                                            }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"></td>
                                                        <th class="white-space-nowrap text-right"> VAT</th>
                                                        <td class="white-space-nowrap text-center">
                                                            {{ parseFloat((booking.total_excl_vat) * vat).toFixed(2) }}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="3"></td>
                                                        <th class="white-space-nowrap text-right">Total incl. VAT</th>
                                                        <td class="white-space-nowrap text-center">
                                                            {{ totalInclVat.toFixed(2) }}
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-if="booking.clientId.id && !booking.clientAgreement">
                                                No agreement chosen - standard prices shown
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <br/>
                <br/>

                <div class="row">
                    <div class="col-md-12">
                        <div class="p-4 mb-4 bg-white rounded-lg h-100">
                            <div class="h3 mb-3">Products</div>
                            <div class="">
                                <div class="pt-3">
                                    <div class="table-responsive">
                                        <table class="table border">
                                            <tbody>
                                            <tr>
                                                <th>Reference</th>
                                                <th>Name</th>
                                                <th>Colli</th>
                                                <th>Volume(m3)</th>
                                                <th>Weight(kg)</th>
                                                <th></th>
                                            </tr>

                                            <tr v-for="colli in booking.colli">
                                                <td>{{ colli.reference }}</td>
                                                <td>{{ colli.name }}</td>
                                                <td>{{ colli.colli }}</td>
                                                <td>{{ colli.volume }}</td>
                                                <td>{{ colli.weight }}</td>
                                                <td></td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="off"
                                                               class="form-control"
                                                               placeholder="123456 (order #)"
                                                               v-model="colli.reference">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="off"
                                                               class="form-control"
                                                               placeholder="Blue chair"
                                                               v-model="colli.name">
                                                    </div>
                                                </td>

                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="off"
                                                               class="form-control"
                                                               v-model="colli.colli">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="off"
                                                               class="form-control"
                                                               v-model="colli.volume">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <input type="text"
                                                               autocomplete="off"
                                                               class="form-control"
                                                               v-model="colli.weight">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <div class="btn btn-success sm" @click="addColli()">
                                                            <div
                                                                class="material-icons-outlined cursor-pointer mr-1">
                                                                add_circle
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="showClientColliList">
                                                <td colspan="11">
                                                    <div>
                                                        <b>Products already in the Step Transport warehouse:</b>
                                                    </div>
                                                    <div class="col-md-3 search-colli">
                                                        <div class="form-group">
                                                            <input type="text" autocomplete="off"
                                                                   @input="findColliByReference($event)"
                                                                   class="form-control"
                                                                   placeholder="Search for colli reference...">
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="showClientColliList" v-for="colli in clientColliList">
                                                <td>
                                                    <div class="form-group">
                                                        {{ colli.reference }}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        {{ colli.name }}
                                                    </div>
                                                </td>

                                                <td>
                                                    <div class="form-group">
                                                        {{ colli.totalColliAmountByColliBatch }}
                                                    </div>
                                                </td>

                                                <td>
                                                    {{ colli.totalVolumeByColliBatch }}
                                                </td>
                                                <td>
                                                    {{ colli.totalWeightByColliBatch }}
                                                </td>
                                                <td>
                                                    <div class="form-group">
                                                        <div class="btn btn-success sm"
                                                             @click="addExistingColli(colli.id)">
                                                            <div
                                                                class="material-icons-outlined cursor-pointer mr-1">
                                                                add_circle
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                        <div
                                            v-if="!showClientColliList && type === typeFlex && booking.clientAgreement"
                                            class="btn add-warehouse btn-success"
                                            @click="getClientColliList">
                                            Add from Step Warehouse
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-success btn-lg mt-5" @click="validation()">Create
                            booking
                        </button>
                    </div>
                </div>

            </div>
        </form>

        <div
            ref="modal"
            class="modal fade"
            :class="{show, 'd-block': activeModalInterval}"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <div v-if="showInstantDeliveryWarningModal===true"> Missing trip dates</div>
                            <div v-else>
                                {{ showPhoneWarning }}
                                {{ showExchangeServiceWarning }}
                                {{ showNullPriceWarning }}
                                {{ showExeededIntervalWarning }}
                            </div>
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="toggleModal"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="showInstantDeliveryWarningModal===true">

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                        :class="booking.pickupDate==='' && isSubmit? '':''">
                                        <date-picker
                                            manual-input
                                            v-model="booking.pickupDate" valueType="format"
                                            input-class="border-0 py-0 shadow-none form-input"
                                            :lang="datePickerOptions.lang"
                                            placeholder="dd-mm-yyyy" format="DD-MM-YYYY">
                                        </date-picker>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <div
                                        class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                        :class="booking.dropoffDate==='' && isSubmit? '':''">
                                        <date-picker
                                            manual-input
                                            v-model="booking.dropoffDate" valueType="format"
                                            input-class="border-0 py-0 shadow-none form-input"
                                            :lang="datePickerOptions.lang"
                                            placeholder="dd-mm-yyyy" format="DD-MM-YYYY">
                                        </date-picker>
                                        <div class="help-block with-errors"></div>
                                    </div>
                                </div>
                            </div>

                            <button class="btn btn-success" @click="addBooking">
                                Save
                            </button>
                            <div class="btn btn-primary mark-delivered" @click="toggleModal">
                                Cancel
                            </div>

                        </div>
                        <div v-else>
                            <div v-if="showExchangeServiceWarning===''">
                                <div v-if="showNullPriceWarning">
                                    <button class="btn btn-success"
                                            @click="storeValidatedBooking">
                                        Yes
                                    </button>
                                    <div class="btn btn-primary mark-delivered" @click="toggleModal">
                                        No
                                    </div>
                                </div>
                                <div v-else>
                                    <button class="btn btn-success" @click="storeValidatedBooking">
                                        Confirm
                                    </button>
                                    <div class="btn btn-primary mark-delivered" @click="toggleModal">
                                        Cancel
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeModalInterval" class="modal-backdrop fade show"></div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import VueTimepicker from 'vue2-timepicker';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'vue-select/dist/vue-select.css';
import datePickerOptionsMixin from "./../mixins/datePickerOptionsMixin";
import { adressevaelger } from '../vendor/adressevaelger/legacy';
import '../../../public/css/adressevaelger.css';
import agreementAddOnMixin from "../mixins/agreementAddOnMixin";

export default {
    name: "BookingCreate",
    mixins: [datePickerOptionsMixin, agreementAddOnMixin],
    components: {DatePicker, VueTimepicker},
    directives: {
        adressevaelger: {
            inserted(input, binding, vnode) {
                input.adressevaelger = adressevaelger(input, {
                    token: 'adressevaelger123',
                    select: data => vnode.context.handleAutocomplete(binding.value, data),
                });
            },
            unbind(input) {
                if (input.adressevaelger) {
                    input.adressevaelger.destroy();
                }
            },
        },
    },
    props: {
        role: {type: String, required: true},
        roleUser: {type: String, required: true},
        canViewPrices: {type: Boolean, required: true},
        canEditPrices: {type: Boolean, required: true},
        bookingToRecreate: {type: Object, required: false},
        typeFlex: {type: String, required: true},
        typeAdHoc: {type: String, required: true},
        types: {type: Object, required: true},
        configurations: {type: Object, required: true},
        userTypeClient: {type: String, required: true},
        stepAddresses: {type: Object, required: true},
        driverTypeExternal: {type: Number, required: true},
        customServices: {type: Array, required: true},
        addOnIKnowDeliveryPickup: {type: Number, default: 0},
        addOnIKnowDeliveryDropoff: {type: Number, default: 0},
        addOnShorterIntervalPickup: {type: Number, default: 0},
        addOnShorterIntervalDropoff: {type: Number, default: 0},
        tripTypes: {type: Object, required: true},
        tripTypePickup: {type: Number, required: true},
        tripTypeDropoff: {type: Number, required: true},
        customerChoosesOption: {type: String, required: true},
    },
    data() {
        return {
            daysOfWeek: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            countryList: {},
            defaultPickupCountry: 'DK',
            defaultDropoffCountry: 'DK',
            vat: 0.25,
            activeModalInterval: false,
            show: false,
            clientList: [
                {id: '', name: ''},
            ],
            driverList: [
                {id: '', name: ''},
            ],
            pickupClientAddresses: [
                {id: '', value: ''},
            ],
            dropoffClientAddresses: [
                {id: '', value: ''},
            ],
            showInstantDeliveryWarning: false,
            showInstantDeliveryWarningModal: false,
            showPhoneWarning: '',
            showExchangeServiceWarning: '',
            showNullPriceWarning: '',
            showExeededIntervalWarning: '',
            showPhoneWarningIsShownOnce: false,
            showExchangeServiceWarningIsShownOnce: false,
            showNullPriceWarningIsShownOnce: false,
            exchangeServicePresent: false,
            returnServicePresent: false,

            'dropoffAddressSuggestionMatch': false,
            'pickupAddressSuggestionMatch': false,
            selectedAddresses: {pickup: null, dropoff: null},

            booking: {
                'is_instantly_delivered': 0,
                'createDependingBooking': null,
                'clientId': {'id': 0, 'name': ''},
                'driverId': {'id': 0, 'name': ''},
                'clientAgreement': '',
                'pickupAddress': '',
                'dropoffAddress': '',

                'pickupAddressName': '',
                'pickupAddressStreet': '',
                'pickupAddressZip': '',
                'pickupAddressCity': '',
                'pickupAddressPhone': '',
                'pickupAddressPhonePrefix': '+45',
                'pickupAddressCountryId': '1',
                'pickupNote': '',
                'pickupDate': '',
                'pickupTimeStart': '00:00',
                'pickupTimeEnd': '00:00',

                'dropoffAddressName': '',
                'dropoffAddressStreet': '',
                'dropoffAddressZip': '',
                'dropoffAddressCity': '',
                'dropoffAddressPhone': '',
                'dropoffAddressPhonePrefix': '+45',
                'dropoffAddressCountryId': '1',
                'dropoffNote': '',
                'dropoffDate': '',
                'dropoffTimeStart': '00:00',
                'dropoffTimeEnd': '00:00',

                'productId': '',
                'product': {},
                'product_time_units': 0.0,
                'product_price': 0,
                'serviceIds': [],
                'services_data': [],
                'total_service_price': 0,
                'total_excl_vat': 0,
                'linehaulType': '0-0',
                'priceService': {},
                'priceServiceSum': 0,
                'priceProduct': 0,
                'agreement_insurance': {},
                'insurances_price': 0,

                'totalWeight': 0,
                'totalVolume': 0,
                'totalColli': 1,
                'newTotalPriceProductByPiece': 0,
                'newPriceServiceByPiece': {},
                'newPriceServiceByHour': {},
                'newTotalPriceServiceByPiece': 0,
                'newTotalPriceServiceByHour': 0,
                'newIndividualPriceProduct': {},
                'newIndividualPriceService': {},
                'colli': [],
                'note': '',
                'internal_comment': '',
                'pickup_address_type': 1,
                'dropoff_address_type': 1,
                'pickup_email': '',
                'dropoff_email': '',
                'pickup_delivery_is_known': 0,
                'dropoff_delivery_is_known': 0,
                'isExternalDriver': 0,
                'bookingType': 1,
                'cost_price': 0,
            },
            bookingCustomServices: [],
            selectedCustomService: '',
            newCustomService: '',
            colli: {
                'id': '',
                'reference': '',
                'name': '',
                'colli': '',
                'height': '',
                'width': '',
                'measure': '',
                'volume': '',
                'weight': '',
                'isExisting': 0,
                'isRebooking': 0
            },
            clients: {},
            clientAddresses: {},
            clientAgreements: {},
            clientAgreementSingleName: '',
            clientColliList: {},
            products: {},
            services: {},
            agreementAddOnsPickup: [],
            agreementAddOnsDropoff: [],
            selectedAddOnsPickup: [],
            selectedAddOnsDropoff: [],
            selectedAddOnOptions: {},
            linehaulTypes: [],
            isPriceTypeHourlyAvailable: false,
            isSubmit: false,
            exceedInterval: false,
            wrongPriceMessage: '',
            isEditableClient: true,
            isEditableAgreement: true,
            isEditablePrice: true,
            colliSaved: false,
            showClientColliList: false,
            colliReferenceString: '',
            getReferenceFromBookingField: false,
            oldBookingData: {},
            recreateServices: {},
            type: this.typeFlex,
            availableWeekDaysDropoff: {
                1: {from: '00:00', to: '00:00', highlight: false},
                2: {from: '00:00', to: '00:00', highlight: false},
                3: {from: '00:00', to: '00:00', highlight: false},
                4: {from: '00:00', to: '00:00', highlight: false},
                5: {from: '00:00', to: '00:00', highlight: false},
            },
            availableWeekDaysPickup: {
                1: {from: '00:00', to: '00:00', highlight: false},
                2: {from: '00:00', to: '00:00', highlight: false},
                3: {from: '00:00', to: '00:00', highlight: false},
                4: {from: '00:00', to: '00:00', highlight: false},
                5: {from: '00:00', to: '00:00', highlight: false},
            },
            loadingRouteDataDropoff: false,
            loadingRouteDataPickup: false,
            hourRangeDropoff: [0, 24],
            hourRangePickup: [0, 24],
            showIKnowDeliveryButtonPickup: false,
            showIKnowDeliveryButtonDropoff: false,
            showShorterIntervalOptionsPickup: false,
            showShorterIntervalOptionsDropoff: false,
            shorterIntervalOptionsPickup: {},
            shorterIntervalOptionsDropoff: {},
        }
    },
    methods: {
        getLinehaulTypeLabel(type) {
            const labels = {
                '0-0': 'None',
                '1-2': 'EAST-WEST',
                '2-1': 'WEST-EAST'
            };
            return labels[type] || type || 'None';
        },
        onSelectPickupPrefix({name, iso2, dialCode}) {
            this.booking.pickupAddressPhonePrefix = '+' + dialCode;
        },
        onSelectDropoffPrefix({name, iso2, dialCode}) {
            this.booking.dropoffAddressPhonePrefix = '+' + dialCode;
        },
        onChangePickupCountry() {
            let countryData = this.countryList.filter(p => p.id == this.booking.pickupAddressCountryId);
            if (countryData) {
                this.booking.pickupAddressPhonePrefix = countryData[0].phone_prefix;
                this.defaultPickupCountry = countryData[0].code;
            }
            this.pickupAddressManuallyChanged();
        },
        onChangeDropoffCountry() {
            let countryData = this.countryList.filter(p => p.id == this.booking.dropoffAddressCountryId);
            if (countryData) {
                this.booking.dropoffAddressPhonePrefix = countryData[0].phone_prefix;
                this.defaultDropoffCountry = countryData[0].code;
            }
            this.dropoffAddressManuallyChanged();
        },
        onChangePickupAddress(event) {
            this.clearAddressSelection('pickup');
            const defaults = Object.keys(this.stepAddresses);
            if (defaults.includes(event.id)) {
                this.booking.pickupAddressName = this.stepAddresses[event.id].name;
                this.booking.pickupAddressStreet = this.stepAddresses[event.id].street;
                this.booking.pickupAddressZip = this.stepAddresses[event.id].zip;
                this.booking.pickupAddressCity = this.stepAddresses[event.id].city;
                this.booking.pickupAddressCountryId = this.stepAddresses[event.id].country_id;
            } else {
                let addressData = this.clientAddresses.filter(p => p.id == event.id);
                if (addressData.length > 0) {
                    this.booking.pickupAddressName = addressData[0].name;
                    this.booking.pickupAddressStreet = addressData[0].street;
                    this.booking.pickupAddressZip = addressData[0].zip;
                    this.booking.pickupAddressCity = addressData[0].city;
                    this.booking.pickupAddressCountryId = addressData[0].country_id;
                }
            }
        },
        onChangeDropoffAddress(event) {
            this.clearAddressSelection('dropoff');
            const defaults = Object.keys(this.stepAddresses);
            if (defaults.includes(event.id)) {
                this.booking.dropoffAddressName = this.stepAddresses[event.id].name;
                this.booking.dropoffAddressStreet = this.stepAddresses[event.id].street;
                this.booking.dropoffAddressZip = this.stepAddresses[event.id].zip;
                this.booking.dropoffAddressCity = this.stepAddresses[event.id].city;
                this.booking.dropoffAddressCountryId = this.stepAddresses[event.id].country_id;
            } else {
                let addressData = this.clientAddresses.filter(p => p.id == event.id);
                if (addressData.length > 0) {
                    this.booking.dropoffAddressName = addressData[0].name;
                    this.booking.dropoffAddressStreet = addressData[0].street;
                    this.booking.dropoffAddressZip = addressData[0].zip;
                    this.booking.dropoffAddressCity = addressData[0].city;
                    this.booking.dropoffAddressCountryId = addressData[0].country_id;
                }
            }
        },
        getClientColliList() {
            this.showClientColliList = true;
            this.clientColliList = {};
            if (this.booking.clientId.id > 0) {
                axios.get(`/colli-list?clientIdSingle=${this.booking.clientId.id}&groupByColliBatch=true&excludeDelivered=true&excludeAssigned=true`)
                    .then(({data}) => {
                        this.clientColliList = data.data;
                    }).catch()
            }
        },
        findColliByReference(event) {
            this.clientColliList = {};
            if (this.booking.clientId.id > 0) {
                axios.get(`/colli-list?searchByReference=${event.target.value}&clientIdSingle=${this.booking.clientId.id}&groupByColliBatch=true&excludeDelivered=true&excludeAssigned=true`)
                    .then(({data}) => {
                        this.clientColliList = data.data;
                    }).catch()
            }
        },
        addColli() {
            if (this.colli.reference === '') {
                alert('fill out reference');
            } else if (this.colli.name === '') {
                alert('fill out name');
            } else if (this.colli.colli === '') {
                alert('fill out colli number');
            } else if (!/^\d+$/.test(this.colli.colli)) {
                alert('colli should be an integer');
            } else if (this.colli.volume === '') {
                alert('fill out volume');
            } else if (this.colli.weight === '') {
                alert('fill out weight');
            } else {
                this.booking.colli.push({
                    reference: this.colli.reference,
                    name: this.colli.name,
                    colli: this.colli.colli,
                    height: this.colli.height,
                    width: this.colli.width,
                    measure: this.colli.measure,
                    volume: this.colli.volume,
                    weight: this.colli.weight,
                    isExisting: 0,
                });
                this.colliSaved = true;
                this.colliReferenceString += this.colliReferenceString === '' ? this.colli.reference : ' + ' + this.colli.reference;
                this.booking.reference = this.getReferenceFromBookingField === false ? this.colliReferenceString : this.booking.reference;

                this.booking.totalVolume += parseFloat(this.colli.volume.replace(/,/g, '.'));
                this.booking.totalWeight += parseFloat(this.colli.weight.replace(/,/g, '.'));
                this.calculatePrice();
            }
        },
        addExistingColli(id) {
            let existingColliData = this.clientColliList.filter(p => p.id == id)[0];
            this.booking.colli.push({
                id: id,
                reference: existingColliData.reference,
                name: existingColliData.name,
                colli: existingColliData.totalColliAmountByColliBatch,
                height: existingColliData.height,
                width: existingColliData.width,
                volume: existingColliData.totalVolumeByColliBatch,
                weight: existingColliData.totalWeightByColliBatch,
                isExisting: 1,
            });
            this.colliSaved = true;
            this.colliReferenceString += this.colliReferenceString === '' ? existingColliData.reference : '+' + existingColliData.reference;
            this.booking.reference = this.getReferenceFromBookingField === false ? this.colliReferenceString : this.booking.reference;

            this.booking.totalVolume += parseFloat(existingColliData.totalVolume);
            this.booking.totalWeight += parseFloat(existingColliData.totalWeight);
            this.calculatePrice();
            this.clientColliList = this.clientColliList.filter(p => p.id !== id);
        },
        checkServiceName() {
            axios.post(`/booking-check-exchange-service`, this.booking.serviceIds).then((response) => {
                if (response.data.message && response.data.message === true) {
                    this.exchangeServicePresent = response.data.services['exchange'] === true;
                    this.returnServicePresent = response.data.services['return'] === true;
                }
            })
        },
        async calculatePrice() {
            let totalWeight = this.booking.totalWeight;
            let totalVolume = this.booking.totalVolume;
            const clientAgreement = this.booking.clientAgreement ? this.booking.clientAgreement : 0;
            await this.calculatePriceForProduct(totalWeight, totalVolume, clientAgreement);
            await this.calculatePriceForServices(totalWeight, totalVolume, clientAgreement);
            this.recalculateServicePrice();
        },
        calculatePriceForProduct(totalWeight, totalVolume, clientAgreement) {
            return new Promise((resolve) => {
                if (
                    this.booking.productId > 0 &&
                    totalVolume > 0 &&
                    totalWeight > 0
                ) {
                    axios.get(`/product-price-interval/${this.booking.productId}/${totalVolume}/${totalWeight}/product/${clientAgreement}`)
                        .then(({data}) => {
                            if (this.booking.isExternalDriver == 1) {
                                this.booking.priceProduct = 0;
                            } else if (data === '') {
                                this.exceedInterval = true;
                                this.booking.newTotalPriceProductByPiece = 0;
                                this.booking.total_excl_vat = 0;

                                this.booking.newIndividualPriceProduct = {};
                                if (this.booking.productId > 0) {
                                    this.booking.newIndividualPriceProduct[this.booking.productId] = 0;
                                }

                                this.booking.priceProduct = 0;
                            } else {
                                this.exceedInterval = false;
                                this.booking.newTotalPriceProductByPiece = data;
                                this.booking.total_excl_vat = data;

                                this.booking.newIndividualPriceProduct = {};
                                if (this.booking.productId > 0) {
                                    this.booking.newIndividualPriceProduct[this.booking.productId] = parseInt(data)
                                }

                                this.booking.priceProduct = this.booking.newTotalPriceProductByPiece;
                                this.booking.priceServiceSum = this.booking.newTotalPriceServiceByHour;

                            }
                        }).catch((error) => {
                        console.log(error)
                    }).finally(() => {
                        resolve();
                    });
                } else {
                    resolve();
                }
            });
        },
        calculatePriceForServices(totalWeight, totalVolume, clientAgreement) {
            return new Promise((resolve) => {
                if (this.booking.serviceIds.length > 0) {
                    if (
                        totalVolume > 0 &&
                        totalWeight > 0
                    ) {
                        axios.get(`/product-price-interval/${encodeURIComponent(JSON.stringify(this.booking.serviceIds.filter(x => x)))}/${this.booking.totalVolume}/${this.booking.totalWeight}/service/${clientAgreement}`)
                            .then(({data}) => {
                                this.booking.priceService = data.priceService;
                                this.booking.newPriceServiceByPiece = {};
                                this.booking.newPriceServiceByHour = {};
                                Object.entries(this.booking.priceService).forEach(entry => {
                                    const [key, value] = entry;
                                    let priceType = this.services.filter(p => p.id == key)[0].price_type;
                                    this.getBookingServices.filter(item => item.id == key)[0].price = value;
                                    if (priceType === 1) {
                                        this.booking.newPriceServiceByPiece[key] = parseInt(value);
                                    } else {
                                        this.isPriceTypeHourlyAvailable = true;
                                        this.booking.newPriceServiceByHour[key] = parseInt(value);
                                    }
                                    this.booking.newIndividualPriceService[key] = parseInt(value);
                                });

                                this.booking.newTotalPriceServiceByPiece = Object.values(this.booking.newPriceServiceByPiece).reduce((i, a) => i + a, 0);
                                this.booking.newTotalPriceServiceByHour = Object.values(this.booking.newPriceServiceByHour).reduce((i, a) => i + a, 0);
                                this.booking.priceServiceSum = this.booking.newTotalPriceServiceByHour;
                            }).catch(error => this.booking.priceServiceSum = 0).finally(() => {
                                resolve();
                        });
                    } else {
                        resolve();
                    }
                } else {
                    this.booking.newPriceServiceByPiece = {};
                    this.booking.newPriceServiceByHour = {};
                    this.booking.newTotalPriceServiceByPiece = Object.values(this.booking.newPriceServiceByPiece).reduce((i, a) => i + a, 0);
                    this.booking.newTotalPriceServiceByHour = Object.values(this.booking.newPriceServiceByHour).reduce((i, a) => i + a, 0);
                    this.booking.priceProduct = this.booking.newTotalPriceProductByPiece + this.booking.newTotalPriceServiceByPiece;
                    this.booking.priceServiceSum = this.booking.newTotalPriceServiceByHour;
                    resolve();
                }
            })

        },
        validation() {
            let emptyFields = {};

            if (this.booking.pickupAddress === "") {
                emptyFields['field'] = 'client pickup address';
            }
            if (this.booking.dropoffAddress === "") {
                //emptyFields['field'] = 'client dropoff address';
            }
            if (this.booking.clientId.name === "") {
                emptyFields['field'] = 'client name';
            }
            if (this.booking.clientAgreement === "") {
                emptyFields['field'] = 'client agreement';
            }
            if (this.booking.totalWeight === "") {
                emptyFields['field'] = 'total weight';
            }
            if (this.booking.totalVolume === "") {
                emptyFields['field'] = 'total volume';
            }
            if (this.booking.productId === "") {
                emptyFields['field'] = 'products';
            }
            if (Object.keys(emptyFields).length > 0 && this.booking.clientId.name !== "") {
                let message = `Validation error. Empty field: ${emptyFields.field}`;
                axios.get(`/booking-error-notify/${message}/${this.booking.clientId.name}`).then((response) => {
                });
            }
            this.isSubmit = true;
        },
        cleanBookingAfterCreated(cleanDropoff) {
            this.booking.productId = '';
            this.booking.product = {};
            this.booking.serviceIds = [];
            this.booking.product_time_units = 0.0,
                this.booking.product_price = 0,
                this.booking.total_service_price = 0,
                this.booking.total_excl_vat = 0,
                this.booking.services_data = [];
            this.booking.linehaulType = '0-0';
            this.getAgreementsProductsServices();
            if (cleanDropoff) {
                this.booking.pickupAddressPhone = '';
                this.booking.pickupDate = '';
                this.booking.pickupTimeStart = '';
                this.booking.pickupTimeEnd = '';

                this.booking.dropoffAddress = '';
                this.booking.dropoffAddressName = '';
                this.booking.dropoffAddressStreet = '';
                this.booking.dropoffAddressZip = '';
                this.booking.dropoffAddressCity = '';
                this.booking.dropoffAddressCountryId = 1;

                this.booking.dropoffAddressPhone = '';
                this.booking.dropoffDate = '';
                this.booking.dropoffTimeStart = this.configurations[this.type]['default_time_from'];
                this.booking.dropoffTimeEnd = this.configurations[this.type]['default_time_to'];
                this.booking.pickupTimeStart = this.configurations[this.type]['default_time_from_pickup'];
                this.booking.pickupTimeEnd = this.configurations[this.type]['default_time_to_pickup'];
                this.booking.dropoffNote = '';
            }

            this.booking.note = '';
            this.booking.reference = '';

            this.booking.priceService = {};
            this.booking.priceServiceSum = 0;
            this.booking.priceProduct = 0;
            this.booking.totalWeight = 0;
            this.booking.totalVolume = 0;
            this.booking.totalColli = 0;
            this.booking.newTotalPriceProductByPiece = 0;
            this.booking.newPriceServiceByPiece = {};
            this.booking.newPriceServiceByHour = {};
            this.booking.newTotalPriceServiceByPiece = 0;
            this.booking.newTotalPriceServiceByHour = 0;
            this.booking.newIndividualPriceProduct = {};
            this.booking.newIndividualPriceService = {};
            this.exceedInterval = false;
            this.wrongPriceMessage = '';
            this.booking.colli = [];
            this.colli = {};
            this.clientColliList = {};
            this.colliSaved = false;
            this.showClientColliList = false;
            this.exchangeServicePresent = false
            this.returnServicePresent = false;
            this.oldBookingData = {};
            this.colliReferenceString = '';
            this.booking.insurances_price = 0;
            this.booking.agreement_insurance = {};
            this.selectedAddOnsPickup = [];
            this.selectedAddOnsDropoff = [];
            this.selectedAddOnOptions = {};
            this.bookingCustomServices = [];
            this.showIKnowDeliveryButtonPickup = false;
            this.showIKnowDeliveryButtonDropoff = false;
            this.showShorterIntervalOptionsPickup = false;
            this.showShorterIntervalOptionsDropoff = false;
        },
        checkInstantDeliveryWarning() {
            if (
                this.booking.is_instantly_delivered &&
                (
                    this.isEmptyDate(this.booking.pickupDate) ||
                    this.isEmptyDate(this.booking.dropoffDate)
                )
            ) {
                this.showInstantDeliveryWarning = true;
            } else {
                this.showInstantDeliveryWarning = false;
            }
        },
        isEmptyDate(date) {
            return !date || date === '';
        },
        async storeValidatedBooking() {
            await this.setLinehaul();

            let booking = JSON.parse(JSON.stringify(this.booking));
            booking['selectedAddOns'] = this.selectedAddOnsPickup.concat(this.selectedAddOnsDropoff);
            booking['customServices'] = this.bookingCustomServices;

            axios.post('/bookings', booking).then((response) => {
                this.flashMessage.success({
                    title: '',
                    message: 'Booking successfully created',
                    time: 2000,
                    blockClass: 'flash-message'
                });

                if (this.booking.createDependingBooking) {
                    this.cleanBookingAfterCreated(true);
                    this.booking.createDependingBooking = null;
                } else {
                    if (this.returnServicePresent) {
                        this.booking.createDependingBooking = response.data.bookingId;
                        this.oldBookingData = structuredClone(this.booking);

                        this.booking.dropoffAddress = this.oldBookingData.pickupAddress;
                        this.booking.dropoffAddressName = this.oldBookingData.pickupAddressName;
                        this.booking.dropoffAddressStreet = this.oldBookingData.pickupAddressStreet;
                        this.booking.dropoffAddressZip = this.oldBookingData.pickupAddressZip;
                        this.booking.dropoffAddressCity = this.oldBookingData.pickupAddressCity;
                        this.booking.dropoffAddressPhone = this.oldBookingData.pickupAddressPhone;
                        this.booking.dropoffDate = this.oldBookingData.pickupDate;
                        this.booking.dropoffTimeStart = this.oldBookingData.pickupTimeStart;
                        this.booking.dropoffTimeEnd = this.oldBookingData.pickupTimeEnd;

                        this.booking.pickupAddress = this.oldBookingData.dropoffAddress;
                        this.booking.pickupAddressName = this.oldBookingData.dropoffAddressName;
                        this.booking.pickupAddressStreet = this.oldBookingData.dropoffAddressStreet;
                        this.booking.pickupAddressZip = this.oldBookingData.dropoffAddressZip;
                        this.booking.pickupAddressCity = this.oldBookingData.dropoffAddressCity;
                        this.booking.pickupAddressPhone = this.oldBookingData.dropoffAddressPhone;
                        this.booking.pickupDate = this.oldBookingData.dropoffDate;
                        this.booking.pickupTimeStart = this.oldBookingData.dropoffTimeStart;
                        this.booking.pickupTimeEnd = this.oldBookingData.dropoffTimeEnd;

                        this.cleanBookingAfterCreated(false);
                    } else {
                        this.cleanBookingAfterCreated(true);
                        this.booking.createDependingBooking = null;
                    }
                }
                this.setDefaultStepAddress(2)
            }).catch((error) => {
                console.log(error.response);
                let errNotify = error.response.data.message || 'ERROR';
                this.flashMessage.error({
                    title: '',
                    message: errNotify,
                    time: 5000,
                    blockClass: 'flash-message error'
                });
            })
            if (this.show === true) {
                this.toggleModal();
            }
        },
        addBooking() {
            if (this.booking.clientAgreement.length === 0) {
                this.flashMessage.error({
                    title: '',
                    message: 'Booking can\'t be created without an agreement',
                    time: 5000,
                    blockClass: 'flash-message error'
                });
                return;
            }

            if (this.role === 'user') {
                if (this.booking.colli.length === 0) {
                    alert(`Can't create booking without products`);
                    return;
                }
            }

            if (this.showInstantDeliveryWarning === true) {
                this.showInstantDeliveryWarningModal = true;
                this.toggleModal()
            } else {
                this.showInstantDeliveryWarningModal = false;
                this.showExeededIntervalWarning = '';
                this.showNullPriceWarning = '';
                this.showExchangeServiceWarning = '';
                this.showPhoneWarning = '';

                if (
                    (
                        (!this.booking.pickupAddressStreet || !this.booking.pickupAddressName || !this.booking.pickupAddressZip || !this.booking.pickupAddressCity)
                        ||
                        (!this.booking.dropoffAddressStreet || !this.booking.dropoffAddressName || !this.booking.dropoffAddressZip || !this.booking.dropoffAddressCity)
                    )
                    && this.role !== 'user'
                ) {
                    alert('empty address!')
                } else if (this.exceedInterval) {
                    this.showExeededIntervalWarning = 'The volume or weight exceeds the limit. Are you sure you want to create a booking with the current price?';
                    this.toggleModal();
                } else if (this.booking.priceServiceSum == 0 && this.booking.priceProduct == 0 && this.role !== 'user') {
                    this.showNullPriceWarning = 'Are you sure you want to create a booking with a total price of 0 DKK?';
                    this.toggleModal();
                } else {
                    if (this.booking.priceProduct >= 0 || parseFloat(this.booking.priceProduct.replace(/,/g, '.')) >= 0) {
                        if (this.booking.pickupNote === '' &&
                            this.booking.dropoffNote === '' &&
                            this.exchangeServicePresent === true &&
                            !this.showExchangeServiceWarningIsShownOnce
                        ) {
                            this.showExchangeServiceWarning = 'Du har valgt service "Ombytning" og skal derfor angive hvad der skal ombyttes og hvorfor. Dette angives i notes feltet under "driver note"';
                            this.showExchangeServiceWarningIsShownOnce = true;
                            this.toggleModal();
                        } else {
                            if (!this.colliSaved && this.booking.isExternalDriver != 1) {
                                if (this.role === 'user') {
                                    alert('Colli need to be added!');
                                } else {
                                    this.showPhoneWarning = 'Are you sure you want to create booking without any colli?';
                                    this.toggleModal();
                                }
                            } else {
                                if (this.booking.pickupAddressPhone === '' && this.booking.dropoffAddressPhone === '' && !this.showPhoneWarningIsShownOnce) {
                                    this.showPhoneWarning = 'Are you sure you want to create booking without any phone number?';
                                    this.toggleModal();
                                } else {
                                    this.storeValidatedBooking()
                                }
                            }
                        }
                    } else {
                        this.wrongPriceMessage = 'Wrong price';
                    }
                }
            }
        },
        fetchData() {
            axios.get(`/country-list`)
                .then(({data}) => {
                    this.countryList = data.result;
                }).catch()

            this.getClientList();
            axios.get('/linehaul-list')
                .then(({data}) => {
                    this.linehaulTypes = data.data;
                }).catch(error => this.linehaulTypes = [])

            // get all drivers list instead of loading companies
            this.getDriverList();
        }
        ,
        getDriverList() {
            this.driverList = [];
            axios.get(`/driver-list?type=${this.driverTypeExternal}`)
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;

                        if (value.type === 2) {
                            this.driverList.push({
                                id: value.id,
                                name: value.name,
                            });
                        }
                    });
                    if (this.driverList.length > 0) { // @todo - why [1] below?
                        this.booking.driverId = {'id': this.driverList[1].id, 'name': this.driverList[1].name}
                    }
                }).catch();
        }
        ,
        getClientListForRebooking(clientSearch) {
            const urlClients = '/client-list?search=' + clientSearch;
            axios.get(urlClients)
                .then(({data}) => {
                    this.clients = data.data;
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.clientList.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                    if (data.data.length === 1) {
                        this.booking.clientId.id = data.data[0].id;
                        this.booking.clientId.name = data.data[0].name;
                        this.getClientAgreements();
                        this.getClientAddresses();
                        this.isEditableClient = false;
                        this.isEditablePrice = false;
                        //this.getClientColliList();
                    }

                    if (this.booking.pickup_address_type === 1) {
                        this.removeDefaultStepAddress(1);
                    }
                    if (this.booking.dropoff_address_type === 1) {
                        this.removeDefaultStepAddress(2);
                    }
                }).catch(error => this.clients = [])
        }
        ,
        getClientList() {
            if (this.bookingToRecreate) {
                return;
            }
            const urlClients = '/client-list';
            axios.get(urlClients)
                .then(({data}) => {
                    this.clients = data.data;
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        this.clientList.push({
                            id: value.id,
                            name: value.name,
                        });
                    });
                    if (data.data.length === 1) {
                        this.booking.clientId.id = data.data[0].id;
                        this.booking.clientId.name = data.data[0].name;
                        this.getClientAgreements();
                        this.getClientAddresses();
                        this.isEditableClient = false;
                        this.isEditablePrice = false;
                        this.getClientColliList();
                    }
                }).catch(error => this.clients = [])
        }
        ,
        setDefaultStepAddress(type) {
            this.getClientAddresses();

            if (this.booking.clientId.name !== '') {
                if (type === 1) {
                    this.booking.pickupAddressName = this.stepAddresses['default_1']['name'];
                    this.booking.pickupAddressStreet = this.stepAddresses['default_1']['street'];
                    this.booking.pickupAddressZip = this.stepAddresses['default_1']['zip'];
                    this.booking.pickupAddressCity = this.stepAddresses['default_1']['city'];
                    this.booking.pickupAddressCountryId = this.stepAddresses['default_1']['country_id'];
                    this.booking.pickupNote = '';

                    this.booking.pickupAddress = {
                        id: 'default_1',
                        value: this.stepAddresses['default_1']['wholeAddress']
                    }
                } else {
                    this.booking.dropoffAddressName = this.stepAddresses['default_1']['name'];
                    this.booking.dropoffAddressStreet = this.stepAddresses['default_1']['street'];
                    this.booking.dropoffAddressZip = this.stepAddresses['default_1']['zip'];
                    this.booking.dropoffAddressCity = this.stepAddresses['default_1']['city'];
                    this.booking.dropoffAddressCountryId = this.stepAddresses['default_1']['country_id'];
                    this.booking.dropoffNote = '';

                    this.booking.dropoffAddress = {
                        id: 'default_1',
                        value: this.stepAddresses['default_1']['wholeAddress']
                    }
                }
                this.removeDeliveryDate(type);
            }
        },
        removeDefaultStepAddress(type) {
            this.clearAddressSelection(type === 1 ? 'pickup' : 'dropoff');
            this.getClientAddresses();
            if (type === 1) {
                this.booking.pickupAddress = ''
                this.booking.pickupAddressName = '';
                this.booking.pickupAddressStreet = '';
                this.booking.pickupAddressZip = '';
                this.booking.pickupAddressCity = '';
                this.booking.pickupAddressPhone = '';
            } else {
                this.booking.dropoffAddress = ''
                this.booking.dropoffAddressName = '';
                this.booking.dropoffAddressStreet = '';
                this.booking.dropoffAddressZip = '';
                this.booking.dropoffAddressCity = '';
                this.booking.dropoffAddressPhone = '';
            }
        },
        removeDeliveryDate(type) {
            if (type === 1) {
                this.booking.pickupDate = '';
                this.booking.pickupTimeStart = this.configurations[this.type]['default_time_from_pickup'];
                this.booking.pickupTimeEnd = this.configurations[this.type]['default_time_to_pickup'];
            } else {
                this.booking.dropoffDate = '';
                this.booking.dropoffTimeStart = this.configurations[this.type]['default_time_from'];
                this.booking.dropoffTimeEnd = this.configurations[this.type]['default_time_to'];
            }
        },
        getClientAddresses() {
            axios.get(`/client-addresses/${this.booking.clientId.id}`)
                .then(({data}) => {
                    this.clientAddresses = data;

                    const clientDefaultAddress = this.clients.filter(p => p.id === this.booking.clientId.id);
                    this.pickupClientAddresses = [];
                    this.dropoffClientAddresses = [];

                    if (this.booking.pickup_address_type === 1) {
                        this.pickupClientAddresses.push({
                            id: 'default_client',
                            value: `${clientDefaultAddress[0].name} ${clientDefaultAddress[0].billing_address}`
                        });

                        this.booking.pickupAddress = {
                            id: 'default_client',
                            value: `${clientDefaultAddress[0].name} ${clientDefaultAddress[0].billing_address}`
                        }
                        this.booking.pickupAddressName = this.booking.clientId.name;
                        this.booking.pickupAddressStreet = clientDefaultAddress[0].billing_street;
                        this.booking.pickupAddressZip = clientDefaultAddress[0].billing_zip;
                        this.booking.pickupAddressCity = clientDefaultAddress[0].billing_city;
                    }

                    if (this.booking.dropoff_address_type === 1) {
                        this.dropoffClientAddresses.push({
                            id: 'default_client',
                            value: `${clientDefaultAddress[0].name} ${clientDefaultAddress[0].billing_address}`
                        });
                        this.booking.dropoffAddress = {
                            id: 'default_client',
                            value: `${clientDefaultAddress[0].name} ${clientDefaultAddress[0].billing_address}`
                        }
                        this.booking.dropoffAddressName = this.booking.clientId.name;
                        this.booking.dropoffAddressStreet = clientDefaultAddress[0].billing_street;
                        this.booking.dropoffAddressZip = clientDefaultAddress[0].billing_zip;
                        this.booking.dropoffAddressCity = clientDefaultAddress[0].billing_city;
                    }

                    if (this.booking.pickup_address_type === 2) {
                        for (const key in this.stepAddresses) {
                            this.pickupClientAddresses.push({
                                id: key,
                                value: this.stepAddresses[key]['wholeAddress']
                            });
                        }
                    }

                    if (this.booking.dropoff_address_type === 2) {
                        for (const key in this.stepAddresses) {
                            this.dropoffClientAddresses.push({
                                id: key,
                                value: this.stepAddresses[key]['wholeAddress']
                            });
                        }
                    }

                    if (this.booking.pickup_address_type === 3) {
                        const validClientAddresses = Object.values(this.clientAddresses).filter(address => {
                            return address.deleted_at === null && address.type === 1;
                        });

                        validClientAddresses.forEach(address => {
                            const addressString = `${address.name} ${address.street}, ${address.zip}  ${address.city}, ${address.country ? address.country.name : 'Denmark'}`;
                            const found = this.pickupClientAddresses.some(el => el.value === addressString);

                            if (!found) {
                                const id = this.pickupClientAddresses.length + 1;
                                this.pickupClientAddresses.push({
                                    id: parseInt(address.id),
                                    value: addressString
                                });
                            }
                        });
                    }

                    if (this.booking.dropoff_address_type === 3) {
                        const validClientAddresses = Object.values(this.clientAddresses).filter(address => {
                            return address.deleted_at === null && address.type === 2;
                        });

                        validClientAddresses.forEach(address => {
                            const addressString = `${address.name} ${address.street}, ${address.zip}  ${address.city}, ${address.country ? address.country.name : 'Denmark'}`;
                            const found = this.dropoffClientAddresses.some(el => el.value === addressString);

                            if (!found) {
                                const id = this.dropoffClientAddresses.length + 1;
                                this.dropoffClientAddresses.push({
                                    id: parseInt(address.id),
                                    value: addressString
                                });
                            }
                        });
                    }
                }).catch()
        }
        ,
        getClientAgreements() {
            axios.get(`/client-agreements/${this.booking.clientId.id}`)
                .then(({data}) => {
                    this.clientAgreements = data;
                    let selectedPrimaryAgreement;
                    if (data !== []) {
                        selectedPrimaryAgreement = data.filter(p => p.primary_agreement === 1);
                    }
                    if (this.clientAgreements.length !== 0 && selectedPrimaryAgreement) {
                        if (selectedPrimaryAgreement.length > 0) {
                            this.booking.clientAgreement = selectedPrimaryAgreement[0].id;
                        } else {
                            this.booking.clientAgreement = data[0].id;
                        }
                        this.getAgreementsProductsServices();
                        if (data.length === 1) {
                            this.isEditableAgreement = false;
                            this.clientAgreementSingleName = data[0].name;
                        }
                    } else {
                        this.getAgreementsProductsServices();
                        this.booking.clientAgreement = '';
                        this.isEditableAgreement = false;
                    }
                }).catch(error => this.clientAgreements = [])
        },
        getAgreementsProductsServices() {
            let agreementData = this.clientAgreements.filter(p => p.id === this.booking.clientAgreement);
            if (this.booking.isExternalDriver == 1) {
                axios.get(`/product-list/0`)
                    .then(({data}) => {
                        this.products = data.data;
                        this.booking.productId = data.data.length ? data.data[0].id : null;
                    }).catch(error => this.products = []);

            } else {
                const clientAgreement = this.booking.clientAgreement ? this.booking.clientAgreement : 0;
                axios.get(`/product-list/${clientAgreement}`, {params: {userType: this.userTypeClient}})
                    .then(({data}) => {
                        this.products = data.data;
                        if (data.data.length) {
                            this.booking.productId = data.data[0].id;
                            this.booking.product = data.data[0];
                        }
                    }).catch(error => this.products = []);
                axios.get(`/service-list/${clientAgreement}`, {params: {userType: this.userTypeClient}})
                    .then(({data}) => {
                        this.services = data.data;
                        if (!this.bookingToRecreate) {
                            this.booking.serviceIds = [];
                            this.booking.services_data = [];
                        }
                    }).catch(error => this.services = [])

                this.getAvailableAgreementsAddOns(clientAgreement, this.userTypeClient).then(() => {
                    this.agreementAddOnsPickup.forEach((agreementAddOn) => {
                        if (agreementAddOn.pre_selected) {
                            this.selectedAddOnsPickup.push(agreementAddOn);
                        }
                    });
                    this.agreementAddOnsDropoff.forEach((agreementAddOn) => {
                        if (agreementAddOn.pre_selected) {
                            this.selectedAddOnsDropoff.push(agreementAddOn);
                        }
                    });
                    setTimeout(() => {
                        this.recalculateServicePrice();
                        if (this.selectedAddOnsPickup.length) {
                            this.onSelectAddOn(this.tripTypePickup, true);
                        }
                        if (this.selectedAddOnsDropoff.length) {
                            this.onSelectAddOn(this.tripTypeDropoff, true);
                        }
                    }, 50);
                });
            }
        },
        getCityByZip: function (event, type) {
            this[`${type}AddressManuallyChanged`]();
            const zip = event.target.value;
            const countryId = this.booking[`${type}AddressCountryId`];
            if (type === 'pickup') {
                axios.get(`/get-city-by-zip/${event.target.value}/${this.booking.pickupAddressCountryId}`)
                    .then(({data}) => {
                        if (this.booking.pickupAddressZip !== zip || this.booking.pickupAddressCountryId !== countryId) {
                            return;
                        }
                        if (data.data.city) {
                            this.booking.pickupAddressCity = data.data.city;
                        }
                    }).catch();
            } else {
                axios.get(`/get-city-by-zip/${event.target.value}/${this.booking.dropoffAddressCountryId}`)
                    .then(({data}) => {
                        if (this.booking.dropoffAddressZip !== zip || this.booking.dropoffAddressCountryId !== countryId) {
                            return;
                        }
                        if (data.data.city) {
                            this.booking.dropoffAddressCity = data.data.city;
                        }
                    }).catch();
            }
        },
        setLinehaul() {
            return new Promise((resolve) => {
                //set linehaul dependent on zip
                if (this.booking.dropoffAddressCountryId &&
                    this.booking.pickupAddressCountryId &&
                    (this.booking.dropoffAddressCountryId > 1 ||
                        this.booking.pickupAddressCountryId > 1)
                ) {
                    this.booking.linehaulType = '0-0';
                    resolve();
                    return;
                }

                if (this.booking.pickupAddressZip < 5000) {
                    if (this.booking.dropoffAddressZip >= 5000) {
                        this.booking.linehaulType = '1-2';
                    } else {
                        this.booking.linehaulType = '0-0';
                    }
                } else {
                    if (this.booking.pickupAddressZip >= 5000) {
                        if (this.booking.dropoffAddressZip < 5000) {
                            this.booking.linehaulType = '2-1';
                        } else {
                            this.booking.linehaulType = '0-0';
                        }
                    }
                }
                resolve();
            })
        },
        toggleModal() {
            const body = document.querySelector("body");
            this.activeModalInterval = !this.activeModalInterval;
            this.activeModalInterval
                ? body.classList.add("modal-open")
                : body.classList.remove("modal-open");
            setTimeout(() => (this.show = !this.show), 10);
        },
        onSelectExternalDriver() {
            this.getDriverList();
            if (this.booking.isExternalDriver == 1) {
                this.booking.priceProduct === 0;
                //this.booking.priceServiceSum === 0;
            }
        },
        recalculateTimeUnitsProduct(event, id, time_unit_old) {
            const productUnit = parseFloat(event.target.value);
            if (productUnit > 0) {
                if (time_unit_old > 0) {
                    this.booking.priceProduct = parseFloat(productUnit * this.booking.priceProduct / time_unit_old).toFixed(2);
                }
                this.booking.product_time_units = productUnit;
            } else if (productUnit === 0) {
                this.booking.product_time_units = 0;
            }
        },
        chooseService(service) {
            if (this.booking.services_data.filter(item => item.service.id === service.service.id).length === 0) {
                this.booking.services_data.push(service);
            } else {
                const index = this.booking.services_data.indexOf(service.id);
                this.booking.services_data.splice(index, 1);
                this.recalculateServicePrice();
            }
        },
        recalculateTimeUnitsService(event, id, time_unit_old) {
            const serviceUnit = parseFloat(event.target.value);
            let serviceDataEditable = this.booking.services_data.filter(p => p.id == id);
            if (serviceUnit > 0) {
                if (time_unit_old > 0) {
                    serviceDataEditable[0].price = parseFloat(serviceUnit * serviceDataEditable[0].price / time_unit_old).toFixed(2);
                }
                serviceDataEditable[0].time_unit = serviceUnit;
            } else if (serviceUnit === 0) {
                serviceDataEditable[0].time_unit = 0;
            }
            this.booking.total_service_price = parseFloat(serviceDataEditable[0].price).toFixed(2);
            this.booking.total_excl_vat = parseFloat(this.booking.total_service_price) + parseFloat(this.booking.priceProduct);
            const self = this;
            this.selectedAddOnsPickup.map(item => {
                if (item.price) {
                    self.booking.total_excl_vat += parseFloat(item.price);
                }
            });
            this.selectedAddOnsDropoff.map(item => {
                if (item.price) {
                    self.booking.total_excl_vat += parseFloat(item.price);
                }
            })
        },
        recalculateServicePrice() {
            this.booking.total_excl_vat = 0;
            const self = this;
            self.booking.total_service_price = 0;
            this.booking.services_data.map(item => {
                self.booking.total_service_price += parseFloat(item.price);
            });

            this.booking.total_excl_vat = parseFloat(this.booking.total_service_price ? this.booking.total_service_price : 0) +
                parseFloat(this.booking.priceProduct) +
                parseFloat(this.booking.insurances_price);

            this.selectedAddOnsPickup.map(item => {
                if (item.price) {
                    self.booking.total_excl_vat += parseFloat(item.price);
                }
            });
            this.selectedAddOnsDropoff.map(item => {
                if (item.price) {
                    self.booking.total_excl_vat += parseFloat(item.price);
                }
            });

            this.bookingCustomServices.map(item => {
                if (item.price) {
                    self.booking.total_excl_vat += parseFloat(item.price);
                }
            });
        },

        prefillBookingData() {
            const bookingToRecreate = this.bookingToRecreate;
            this.booking.booking_id = bookingToRecreate.id;

            this.booking.clientId = bookingToRecreate.client;
            this.getClientListForRebooking(this.booking.clientId.name);


            if (bookingToRecreate.driver) {
                this.booking.driverId = bookingToRecreate.driver;
                this.booking.isExternalDriver = 1;
            }

            this.getClientAgreements();
            this.booking.clientAgreement = bookingToRecreate.agreement_id;

            this.booking.pickupAddressName = bookingToRecreate.pickup_address.name;
            this.booking.pickupAddressStreet = bookingToRecreate.pickup_address.street;
            this.booking.pickupAddressZip = bookingToRecreate.pickup_address.zip;
            this.booking.pickupAddressCity = bookingToRecreate.pickup_address.city;
            this.booking.pickupAddressPhone = bookingToRecreate.pickup_address.phone;
            this.booking.pickupAddressCountryId = bookingToRecreate.pickup_address.country_id;
            if (bookingToRecreate.pickup_start && !bookingToRecreate.pickup_start.includes('0000-00-00')) {
                const pickupStart = new Date(bookingToRecreate.pickup_start);
                this.booking.pickupDate = pickupStart.toISOString().substr(0, 10);
                this.booking.pickupTimeStart = {
                    'HH': `${pickupStart.getHours().toString().padStart(2, '0')}`,
                    'mm': `${pickupStart.getMinutes().toString().padStart(2, '0')}`
                };
                const pickupEnd = new Date(bookingToRecreate.pickup_end);
                this.booking.pickupTimeEnd = {
                    'HH': `${pickupEnd.getHours().toString().padStart(2, '0')}`,
                    'mm': `${pickupEnd.getMinutes().toString().padStart(2, '0')}`
                };
            }
            this.booking.pickup_email = bookingToRecreate.pickup_email;
            this.booking.pickupNote = bookingToRecreate.pickup_note;
            this.booking.pickup_address_type = bookingToRecreate.pickup_address_type;

            this.booking.dropoffAddressName = bookingToRecreate.dropoff_address.name;
            this.booking.dropoffAddressStreet = bookingToRecreate.dropoff_address.street;
            this.booking.dropoffAddressZip = bookingToRecreate.dropoff_address.zip;
            this.booking.dropoffAddressCity = bookingToRecreate.dropoff_address.city;
            this.booking.dropoffAddressPhone = bookingToRecreate.dropoff_address.phone;
            this.booking.dropoffAddressCountryId = bookingToRecreate.dropoff_address.country_id;
            if (bookingToRecreate.dropoff_start && !bookingToRecreate.dropoff_start.includes('0000-00-00')) {
                const dropoffStart = new Date(bookingToRecreate.dropoff_start);
                this.booking.dropoffDate = dropoffStart.toISOString().substr(0, 10);
                this.booking.dropoffTimeStart = {
                    'HH': `${dropoffStart.getHours().toString().padStart(2, '0')}`,
                    'mm': `${dropoffStart.getMinutes().toString().padStart(2, '0')}`
                };
                const dropoffEnd = new Date(bookingToRecreate.dropoff_end);
                this.booking.dropoffTimeEnd = {
                    'HH': `${dropoffEnd.getHours().toString().padStart(2, '0')}`,
                    'mm': `${dropoffEnd.getMinutes().toString().padStart(2, '0')}`
                };
            }
            this.booking.dropoff_email = bookingToRecreate.dropoff_email;
            this.booking.dropoffNote = bookingToRecreate.dropoff_note;
            this.booking.dropoff_address_type = bookingToRecreate.dropoff_address_type;

            this.booking.note = bookingToRecreate.note;
            this.booking.reference = bookingToRecreate.reference;

            this.booking.productId = bookingToRecreate.product.id;
            this.booking.linehaulType = bookingToRecreate.linehaul_type;

            this.booking.colli = bookingToRecreate.collis;
            this.booking.colli.map(item => {
                item.isExisting = 0;
            });
            let totalWeight = 0;
            let totalVolume = 0;
            this.booking.colli.map(coli => {
                totalWeight += parseFloat(coli.weight);
                totalVolume += parseFloat(coli.volume);
            })
            this.booking.totalWeight = totalWeight;
            this.booking.totalVolume = totalVolume;

            const service_prices = JSON.parse(bookingToRecreate.service_price);
            const chosenServiceIds = [];
            let servicePrices = 0;
            Object.entries(service_prices).forEach(entry => {
                const [key, value] = entry;
                chosenServiceIds.push(parseInt(key));
                servicePrices += value;
            });
            this.recreateServices = service_prices;

            this.booking.priceServiceSum = servicePrices;
            this.booking.priceProduct = bookingToRecreate.product_price

            const serviceIds = [];
            bookingToRecreate.agreement.services.forEach(agreementService => {
                if (chosenServiceIds.includes(agreementService.service_id)) {
                    serviceIds.push(agreementService.id);
                }
            });

            let addOnPriceTotal = 0;
            bookingToRecreate.agreement_add_ons.forEach((item) => {
                if (item.add_on.type === this.tripTypePickup) {
                    this.selectedAddOnsPickup.push({
                        id: item.id,
                        name: item.add_on.name,
                        price: item.pivot.price
                    });
                } else if (item.add_on.type === this.tripTypeDropoff) {
                    this.selectedAddOnsDropoff.push({
                        id: item.id,
                        name: item.add_on.name,
                        price: item.pivot.price
                    });
                }

                addOnPriceTotal += parseFloat(item.pivot.price);
            });
            this.booking.serviceIds = serviceIds;
            this.booking.total_excl_vat = bookingToRecreate.product_price + servicePrices + addOnPriceTotal;
            this.colliSaved = true;

            if (this.booking.pickup_address_type === 2) {
                for (const key in this.stepAddresses) {
                    this.pickupClientAddresses.push({
                        id: key,
                        value: this.stepAddresses[key]['wholeAddress']
                    });
                }
                if (bookingToRecreate.pickup_address.name === this.stepAddresses['default_1']['name'] &&
                    bookingToRecreate.pickup_address.city === this.stepAddresses['default_1']['city']
                ) {
                    this.booking.pickupAddress = {
                        id: 'default_1',
                        value: this.stepAddresses['default_1']['wholeAddress']
                    }
                } else {
                    this.booking.pickupAddress = {
                        id: 'default_2',
                        value: this.stepAddresses['default_2']['wholeAddress']
                    }
                }
            }

            if (this.booking.dropoff_address_type === 2) {
                for (const key in this.stepAddresses) {
                    this.dropoffClientAddresses.push({
                        id: key,
                        value: this.stepAddresses[key]['wholeAddress']
                    });
                }
                if (bookingToRecreate.dropoff_address.name === this.stepAddresses['default_1']['name'] &&
                    bookingToRecreate.dropoff_address.city === this.stepAddresses['default_1']['city']
                ) {
                    this.booking.dropoffAddress = {
                        id: 'default_1',
                        value: this.stepAddresses['default_1']['wholeAddress']
                    }
                } else {
                    this.booking.dropoffAddress = {
                        id: 'default_2',
                        value: this.stepAddresses['default_2']['wholeAddress']
                    }
                }
            }
        },
        getClassesPickup(date) {
            if (this.role === 'user') {
                return '';
            }

            let day = date.getDay().toString();
            if (this.booking.pickupAddressZip &&
                (
                    Object.keys(this.availableWeekDaysPickup).length &&
                    Object.keys(this.availableWeekDaysPickup).includes(day) &&
                    this.availableWeekDaysPickup[day].highlight
                )
            ) {
                return 'text-white bg-success font-weight-bold';
            }

            return '';
        },
        getClassesDropoff(date) {
            if (this.role === 'user') {
                return '';
            }

            let day = date.getDay().toString();
            if (this.booking.dropoffAddressZip &&
                (
                    Object.keys(this.availableWeekDaysDropoff).length &&
                    Object.keys(this.availableWeekDaysDropoff).includes(day) &&
                    this.availableWeekDaysDropoff[day].highlight
                )
            ) {
                return 'text-white bg-success font-weight-bold';
            }

            return '';
        },
        disabledDatesPickup(date) {
            if (this.role !== 'user') {
                return false;
            }

            if (!this.booking.pickupAddressZip ||
                (
                    Object.keys(this.availableWeekDaysPickup).length &&
                    !Object.keys(this.availableWeekDaysPickup).includes(date.getDay().toString())
                )
            ) {
                return true;
            }

            return false;
        },
        disabledDatesDropoff(date) {
            if (this.role !== 'user') {
                return false;
            }

            if (!this.booking.dropoffAddressZip ||
                (
                    Object.keys(this.availableWeekDaysDropoff).length &&
                    !Object.keys(this.availableWeekDaysDropoff).includes(date.getDay().toString())
                )
            ) {
                return true;
            }

            return false;
        },
        getAvailableWeekDays(type, zip) {
            return new Promise((resolve) => {
                this[`availableWeekDays${type}`] = {
                    1: {from: '00:00', to: '00:00', highlight: false},
                    2: {from: '00:00', to: '00:00', highlight: false},
                    3: {from: '00:00', to: '00:00', highlight: false},
                    4: {from: '00:00', to: '00:00', highlight: false},
                    5: {from: '00:00', to: '00:00', highlight: false},
                };
                if (!zip || zip.length < 4) {
                    resolve();
                    return;
                }

                setTimeout(() => {
                    this[`loadingRouteData${type}`] = true;
                    axios.get(`/routes-get-week-days`, {
                            params: {
                                zip: zip,
                                totalVolume: this.booking.totalVolume,
                                totalWeight: this.booking.totalWeight,
                            }
                        })
                        .then((response) => {
                            if (response.data.availableDays && Object.keys(response.data.availableDays).length) {
                                this[`availableWeekDays${type}`] = response.data.availableDays;
                            }
                        }).catch((error) => {
                        console.log(error.response.data);
                    }).finally(() => {
                        this[`loadingRouteData${type}`] = false;
                        resolve();
                    });
                }, 500);
            });
        },
        onClickDatePickup() {
            if (this.role === 'user' && !this.booking.pickupAddressZip) {
                alert('Please enter address before picking a date');
            }
        },
        onClickDateDropoff() {
            if (this.role === 'user' && !this.booking.dropoffAddressZip) {
                alert('Please enter address before picking a date');
            }
        },
        onSelectDatePickup(date) {
            this.setHourRange(date, 'Pickup');
        },
        onSelectDateDropoff(date) {
            this.setHourRange(date, 'Dropoff');

        },
        setHourRange(date, type) {
            let day, from, to;

            if (date) {
                let dateComponents = date.split('-');
                date = `${dateComponents[2]}-${dateComponents[1]}-${dateComponents[0]}`;
                date = new Date(date);
                day = date.getDay().toString();
            }

            let hasAvailableTimeRange = false;
            if (day !== undefined &&
                this[`availableWeekDays${type}`][day] &&
                this[`availableWeekDays${type}`][day]['from'] &&
                this[`availableWeekDays${type}`][day]['to'] &&
                (this[`availableWeekDays${type}`][day]['from'] !== '00:00' || this[`availableWeekDays${type}`][day]['from'] !== '00:00')
            ) {
                from = this[`availableWeekDays${type}`][day]['from'];
                to = this[`availableWeekDays${type}`][day]['to'];
                hasAvailableTimeRange = true;

            } else {
                let prefix = type === 'Pickup' ? '_pickup' : '';
                from = this.configurations[this.type][`default_time_from${prefix}`];
                to = this.configurations[this.type][`default_time_to${prefix}`];
            }

            const range = [from.substring(0, 2), to.substring(0, 2)];
            if (this.role === 'user') {
                this[`hourRange${type}`] = range;

                type = type.toLowerCase();
                this.$set(this.booking, `${type}TimeStart`, from);
                this.$set(this.booking, `${type}TimeEnd`, to);

            } else {
                // Highlight hours selected on a route
                let startTimePicker = this.$refs[`${type}StartTime`];
                let endTimePicker = this.$refs[`${type}EndTime`];
                let ul, elements;

                const start = parseInt(range[0], 10);
                const end = parseInt(range[1], 10);

                const timeRange = Array.from(
                    { length: end - start + 1 },
                    (_, i) => String(start + i).padStart(2, "0")
                );

                for (let picker of [startTimePicker, endTimePicker]) {
                    ul = picker.querySelector('.hours');
                    elements = ul.querySelectorAll('li');
                    for (const element of elements) {
                        element.classList.remove('bg-success');
                        if (hasAvailableTimeRange && timeRange.includes(element.dataset.key)) {
                            element.classList.add('bg-success');
                        }
                    }
                }
            }
        },
        onClickCustomerAddress(type) {
            const typeName = type === 1 ? 'pickup' : 'dropoff';
            this.$set(this.booking, `${typeName}_address_type`, 3);
            this.removeDefaultStepAddress(type);
        },
        handleAutocomplete(typeName, data) {
            const address = data.adresse;
            const postnummer = address.husnummer.postnummer;
            const selected = {
                street: address.adressebetegnelse.replace(`, ${postnummer.postnr} ${postnummer.navn}`, ''),
                zip: postnummer.postnr,
                city: postnummer.navn,
            };
            this.$set(this.booking, `${typeName}AddressStreet`, selected.street);
            this.$set(this.booking, `${typeName}AddressZip`, selected.zip);
            this.$set(this.booking, `${typeName}AddressCity`, selected.city);
            this.$set(this.selectedAddresses, typeName, selected);
        },
        // These two methods are required to catch a situation when address fields were manually changed after
        // some suggestion was selected
        dropoffAddressManuallyChanged() {
            this.addressManuallyChanged('dropoff');
        },
        pickupAddressManuallyChanged() {
            this.addressManuallyChanged('pickup');
        },
        addressManuallyChanged(typeName) {
            const selected = this.selectedAddresses[typeName];
            const inputElm = this.clearAddressSelection(typeName);
            if (selected && inputElm && this.booking[`${typeName}AddressCountryId`] == 1) {
                inputElm.value = this.booking[`${typeName}AddressStreet`] + ', '
                    + this.booking[`${typeName}AddressZip`] + ' '
                    + this.booking[`${typeName}AddressCity`];
                inputElm.focus();
                inputElm.dispatchEvent(new Event('input', {bubbles: true}));
            }
        },
        clearAddressSelection(typeName) {
            this.$set(this.selectedAddresses, typeName, null);
            const inputElm = document.getElementById(`${typeName}AddressStreet`);
            if (inputElm && inputElm.adressevaelger) {
                inputElm.adressevaelger.cancelPendingRequests();
            }
            return inputElm;
        },
        addNewCustomService(name) {
            if (name) {
                this.bookingCustomServices.push({name: name, price: 0});
                this.newCustomService = '';
                this.selectedCustomService = '';
            }
        },
        deleteCustomService(index) {
            this.bookingCustomServices.splice(index, 1);
        },
        onSelectAddOn(type, setPreSelectedOptions = false) {
            const prefix = type === this.tripTypePickup ? 'Pickup' : 'Dropoff';
            this[`showIKnowDeliveryButton${prefix}`] = false;
            this[`showShorterIntervalOptions${prefix}`] = false;
            for (let i in this[`selectedAddOns${prefix}`]) {
                if (this[`selectedAddOns${prefix}`][i]['add_on_id'] === this[`addOnIKnowDelivery${prefix}`]) {
                    this[`showIKnowDeliveryButton${prefix}`] = true;

                } else if (this[`selectedAddOns${prefix}`][i]['add_on_id'] === this[`addOnShorterInterval${prefix}`]) {
                    this[`showShorterIntervalOptions${prefix}`] = true;

                }

                if (this[`selectedAddOns${prefix}`][i]['add_on_id'] === this[`addOnShorterInterval${prefix}`]) {
                    if (!this.selectedAddOnOptions[this[`selectedAddOns${prefix}`][i]['add_on_id']]) {
                        let val = null;
                        let arr;
                        if (setPreSelectedOptions) {
                            let preSelectedOption = null;
                            if (this[`selectedAddOns${prefix}`][i]['pre_selected_options']) {
                                preSelectedOption = this[`selectedAddOns${prefix}`][i]['pre_selected_options']['option'] ?? `${this[`selectedAddOns${prefix}`][i]['pre_selected_options']['from']} - ${this[`selectedAddOns${prefix}`][i]['pre_selected_options']['to']}`;
                            }
                            val = {
                                option: preSelectedOption,
                                price: this[`selectedAddOns${prefix}`][i]['pre_selected_options']['price']
                            };
                        } else {
                            arr = this[`selectedAddOns${prefix}`][i].configurations.filter((item) => {
                                return item['option'];
                            });
                            val = arr[0];
                        }
                        this.$set(this.selectedAddOnOptions, this[`selectedAddOns${prefix}`][i]['add_on_id'], val);
                        this.onSelectAddOnOption(this[`selectedAddOns${prefix}`][i]['add_on_id'], type);
                        let options = [];
                        let option;
                        for (let j in this[`selectedAddOns${prefix}`][i].configurations) {
                            option = this[`selectedAddOns${prefix}`][i].configurations[j]['option'] ??
                                `${this[`selectedAddOns${prefix}`][i].configurations[j]['from']} - ${this[`selectedAddOns${prefix}`][i].configurations[j]['to']}`

                            options.push({
                                option: option,
                                price: this[`selectedAddOns${prefix}`][i].configurations[j]['price']
                            });
                        }

                        const key = `shorterIntervalOptions${prefix}`;

                        this.$set(this, key, options);
                    }
                }
            }
        },
        onSelectAddOnOption(addOnId, type) {
            const prefix = type === this.tripTypePickup ? 'Pickup' : 'Dropoff';
            for (let i in this[`selectedAddOns${prefix}`]) {
                if (this[`selectedAddOns${prefix}`][i].add_on_id === addOnId && this.selectedAddOnOptions[addOnId]) {
                    this.$set(this[`selectedAddOns${prefix}`][i], 'price', this.selectedAddOnOptions[addOnId].price);
                    this.$set(
                        this[`selectedAddOns${prefix}`][i],
                        'selected_option',
                        this.selectedAddOnOptions[addOnId].option
                    );

                    if ([this.addOnShorterIntervalPickup, this.addOnShorterIntervalDropoff].includes(this[`selectedAddOns${prefix}`][i].add_on_id) &&
                        this.selectedAddOnOptions[addOnId].option !== this.customerChoosesOption
                    ) {
                        let range = this.selectedAddOnOptions[addOnId].option.split('-');
                        let from = range[0].trim();
                        let to = range[1].trim();
                        const prefixLowercase = prefix.toLowerCase();
                        this.$set(this.booking, `${prefixLowercase}TimeStart`, from);
                        this.$set(this.booking, `${prefixLowercase}TimeEnd`, to);
                    }
                }
            }
            this.recalculateServicePrice();
        }
    },
    computed: {
        isSingleMatchDropoff() {
            const selected = this.selectedAddresses.dropoff;
            return !!selected && this.booking.dropoffAddressCountryId == 1 &&
                this.booking.dropoffAddressStreet === selected.street &&
                this.booking.dropoffAddressZip === selected.zip &&
                this.booking.dropoffAddressCity === selected.city;
        },
        isSingleMatchPickup() {
            const selected = this.selectedAddresses.pickup;
            return !!selected && this.booking.pickupAddressCountryId == 1 &&
                this.booking.pickupAddressStreet === selected.street &&
                this.booking.pickupAddressZip === selected.zip &&
                this.booking.pickupAddressCity === selected.city;
        },
        adjustedDaysOfWeek() {
            // Move Monday to the beginning of the array
            const startDayIndex = this.daysOfWeek.indexOf('Monday');
            const adjustedDays = [...this.daysOfWeek.slice(startDayIndex), ...this.daysOfWeek.slice(0, startDayIndex)];
            return adjustedDays;
        },
        hasBookingProduct() {
            return this.booking.product.product;
        },
        getBookingProduct() {
            return this.booking.product;
        },
        getBookingServices() {
            if (Object.keys(this.services).length !== 0) {
                return this.services.filter(item => this.booking.serviceIds.includes(item.id));
            } else {
                return 0;
            }
        },
        totalInclVat() {
            return this.booking.total_excl_vat + this.booking.total_excl_vat * this.vat;
        },
    },
    created() {
        if (this.bookingToRecreate) {
            this.fetchData();
            this.prefillBookingData();
        } else {
            return this.fetchData()
        }
    },
    watch: {
        'booking.is_instantly_delivered'() {
            this.checkInstantDeliveryWarning();
        },
        'booking.pickupDate'() {
            this.checkInstantDeliveryWarning();
        },
        'booking.dropoffDate'() {
            this.checkInstantDeliveryWarning();
        },
        'booking.clientAgreement'(newVal) {
            this.type = this.typeFlex;
            for (let i = 0; i < this.clientAgreements.length; i++) {
                if (this.clientAgreements[i].id === newVal) {
                    if (this.clientAgreements[i].type == this.typeAdHoc) {
                        this.$set(this.booking, 'pickup_delivery_is_known', 0);
                        this.$set(this.booking, 'dropoff_delivery_is_known', 0);
                        this.type = this.typeAdHoc;
                        this.showClientColliList = false;
                    }
                }
            }
            setTimeout(() => {
                this.$set(this.booking, 'dropoffTimeStart', this.configurations[this.type]['default_time_from']);
                this.$set(this.booking, 'dropoffTimeEnd', this.configurations[this.type]['default_time_to']);
                this.$set(this.booking, 'pickupTimeStart', this.configurations[this.type]['default_time_from_pickup']);
                this.$set(this.booking, 'pickupTimeEnd', this.configurations[this.type]['default_time_to_pickup']);
                this.$set(this.booking, 'type', this.type);
            }, 50);
        },
        'booking.dropoffAddressZip'(newVal) {
            this.getAvailableWeekDays('Dropoff', newVal).then(() => {
                if (this.booking.dropoffDate) {
                    this.setHourRange(this.booking.dropoffDate, 'Dropoff');
                }
            });
        },
        'booking.pickupAddressZip'(newVal) {
            this.getAvailableWeekDays('Pickup', newVal). then(() => {
                if (this.booking.pickupDate) {
                    this.setHourRange(this.booking.pickupDate, 'Pickup');
                }
            });
        },
    }
}
</script>

<style>
.flash-message {
    z-index: 10000;
    position: absolute;
    top: 105px;
    left: 30%;
    right: 0;
    background-color: #ffffff !important;
    border: none !important;
}

.flash-message p {
    height: 16px;
    /* Label (Small) */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */
    letter-spacing: 0.02em;
    /* Dark Grey */
    color: #777777;
}

._vue-flash-msg-body__title {
    position: relative;
    width: 63px;
    height: 30px;
    left: 46px;
    top: 1px;
}

._vue-flash-msg-body__title:before {
    /* Label (Bold) */
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    /* or 150% */
    letter-spacing: 0.02em;
    color: #000000;
    content: "Success";
}

._vue-flash-msg-body__text {
    position: relative;
    left: 46px;
    top: 5px;
}

._vue-flash-msg-body__content:before {
    content: url('/checkmark_circle.png');
    left: 5px;
    top: 45%;
    position: relative;
}

.search-colli {
    position: relative;
    left: -16px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.dependent-booking {
    color: red;
}


.address-type {
    margin-left: 15px;
    border: 0.5px solid black;
}

.hide-agreement, .hide-linehaul {
    display: none;
}

</style>

<style scoped>

.general-row {
    min-height: 650px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type=number] {
    -moz-appearance: textfield;
}
</style>
